module.exports = {
  title: 'Canada',
  version: '1.1.2',
  type: 'FeatureCollection',
  copyright: 'Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth',
  copyrightShort: 'Natural Earth',
  copyrightUrl: 'http://www.naturalearthdata.com',
  crs: {
    type: 'name',
    properties: {
      name: 'urn:ogc:def:crs:EPSG:102002'
    }
  },
  'hc-transform': {
    default: {
      rotation: -0.0872664625997,
      crs: '+proj=lcc +lat_1=50 +lat_2=70 +lat_0=40 +lon_0=-96 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs',
      scale: 0.000128658751263,
      jsonres: 15.5,
      jsonmarginX: -999,
      jsonmarginY: 9851,
      xoffset: -2521511.95594,
      yoffset: 4974352.42937
    }
  },
  features: [
    {
      type: 'Feature',
      id: 'CA.5682',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.52,
        'hc-middle-y': 0.5,
        'hc-key': 'ca-5682',
        'hc-a2': 'NU',
        labelrank: '20',
        hasc: '-99',
        'alt-name': null,
        'woe-id': '-99',
        subregion: null,
        fips: null,
        'postal-code': null,
        name: null,
        country: 'Canada',
        'type-en': null,
        region: null,
        longitude: '-61.4664',
        'woe-name': null,
        latitude: '47.7941',
        'woe-label': null,
        type: null
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [8705, 3454],
            [8701, 3445],
            [8696, 3445],
            [8700, 3452],
            [8705, 3454]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.BC',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.54,
        'hc-key': 'ca-bc',
        'hc-a2': 'BC',
        labelrank: '2',
        hasc: 'CA.BC',
        'alt-name': 'Colombie britannique|New Caledonia',
        'woe-id': '2344916',
        subregion: 'British Columbia',
        fips: 'CA02',
        'postal-code': 'BC',
        name: 'British Columbia',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Western Canada',
        longitude: '-124.662',
        'woe-name': 'British Columbia',
        latitude: '54.6943',
        'woe-label': 'British Columbia, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-488, 2785],
              [-490, 2732],
              [-516, 2741],
              [-524, 2789],
              [-488, 2785]
            ]
          ],
          [
            [
              [-310, 2847],
              [-257, 2839],
              [-236, 2813],
              [-272, 2806],
              [-310, 2847]
            ]
          ],
          [
            [
              [-370, 3310],
              [-461, 3275],
              [-418, 3328],
              [-340, 3338],
              [-370, 3310]
            ]
          ],
          [
            [
              [-452, 3444],
              [-485, 3387],
              [-462, 3464],
              [-421, 3467],
              [-452, 3444]
            ]
          ],
          [
            [
              [-582, 3613],
              [-567, 3581],
              [-586, 3571],
              [-589, 3628],
              [-630, 3697],
              [-629, 3756],
              [-578, 3674],
              [-582, 3613]
            ]
          ],
          [
            [
              [-468, 3651],
              [-469, 3608],
              [-493, 3617],
              [-471, 3681],
              [-425, 3682],
              [-468, 3651]
            ]
          ],
          [
            [
              [-613, 3794],
              [-634, 3811],
              [-616, 3835],
              [-580, 3840],
              [-566, 3808],
              [-613, 3794]
            ]
          ],
          [
            [
              [-210, 2665],
              [-178, 2631],
              [-163, 2578],
              [-213, 2647],
              [-210, 2665],
              [-210, 2665],
              [-210, 2665]
            ]
          ],
          [
            [
              [-210, 2666],
              [-210, 2665],
              [-210, 2665],
              [-210, 2665],
              [-211, 2666],
              [-210, 2666],
              [-210, 2666],
              [-210, 2666]
            ]
          ],
          [
            [
              [639, 4744],
              [1038, 4617],
              [669, 3324],
              [685, 3260],
              [664, 3269],
              [673, 3220],
              [717, 3194],
              [723, 3157],
              [749, 3135],
              [759, 3156],
              [783, 3123],
              [789, 3066],
              [817, 3013],
              [812, 2944],
              [845, 2962],
              [874, 2937],
              [859, 2912],
              [881, 2873],
              [920, 2872],
              [947, 2764],
              [985, 2775],
              [1042, 2611],
              [1088, 2562],
              [1079, 2537],
              [1115, 2502],
              [1128, 2458],
              [1155, 2456],
              [1177, 2404],
              [1173, 2275],
              [1148, 2235],
              [1184, 2143],
              [1205, 2135],
              [1220, 2088],
              [-11, 2407],
              [-32, 2435],
              [-58, 2422],
              [-54, 2537],
              [-93, 2528],
              [-140, 2575],
              [-145, 2602],
              [-104, 2639],
              [-120, 2663],
              [-145, 2639],
              [-210, 2666],
              [-210, 2666],
              [-210, 2666],
              [-196, 2732],
              [-173, 2754],
              [-243, 2729],
              [-209, 2784],
              [-215, 2827],
              [-249, 2856],
              [-295, 2850],
              [-417, 2918],
              [-405, 2946],
              [-365, 2963],
              [-363, 2999],
              [-445, 2998],
              [-496, 3062],
              [-510, 3123],
              [-445, 3181],
              [-413, 3184],
              [-334, 3155],
              [-413, 3198],
              [-482, 3166],
              [-483, 3217],
              [-459, 3266],
              [-418, 3288],
              [-325, 3304],
              [-343, 3347],
              [-435, 3327],
              [-438, 3400],
              [-472, 3369],
              [-408, 3486],
              [-436, 3467],
              [-456, 3489],
              [-440, 3550],
              [-465, 3601],
              [-455, 3657],
              [-434, 3652],
              [-413, 3692],
              [-371, 3735],
              [-430, 3699],
              [-478, 3686],
              [-512, 3644],
              [-554, 3796],
              [-528, 3835],
              [-554, 3838],
              [-564, 3887],
              [-516, 3962],
              [-452, 4004],
              [-534, 3970],
              [-416, 4053],
              [-387, 4162],
              [-357, 4182],
              [-357, 4227],
              [-388, 4245],
              [-388, 4272],
              [-438, 4338],
              [-473, 4400],
              [-497, 4410],
              [-485, 4455],
              [-504, 4480],
              [-479, 4509],
              [-507, 4536],
              [-484, 4553],
              [-488, 4629],
              [-485, 4850],
              [-499, 4940],
              [-524, 4979],
              [-519, 5029],
              [-530, 5082],
              [-549, 5100],
              [-549, 5137],
              [-528, 5157],
              [-547, 5229],
              [-652, 5239],
              [-697, 5188],
              [-726, 5171],
              [-748, 5183],
              [-832, 5171],
              [-812, 5244],
              [-847, 5398],
              [-840, 5428],
              [-861, 5470],
              [-860, 5470],
              [639, 4744]
            ]
          ],
          [
            [
              [-474, 3336],
              [-471, 3309],
              [-440, 3349],
              [-441, 3319],
              [-489, 3260],
              [-501, 3173],
              [-526, 3191],
              [-523, 3223],
              [-498, 3235],
              [-514, 3276],
              [-492, 3303],
              [-506, 3363],
              [-474, 3336]
            ]
          ],
          [
            [
              [-502, 3619],
              [-515, 3567],
              [-490, 3611],
              [-448, 3560],
              [-449, 3526],
              [-491, 3451],
              [-481, 3451],
              [-487, 3415],
              [-510, 3423],
              [-509, 3450],
              [-504, 3450],
              [-512, 3453],
              [-484, 3515],
              [-553, 3435],
              [-563, 3538],
              [-541, 3497],
              [-518, 3575],
              [-536, 3591],
              [-502, 3619]
            ]
          ],
          [
            [
              [-541, 3574],
              [-555, 3567],
              [-559, 3644],
              [-587, 3755],
              [-587, 3720],
              [-614, 3760],
              [-568, 3795],
              [-541, 3739],
              [-516, 3637],
              [-540, 3637],
              [-541, 3574]
            ]
          ],
          [
            [
              [-127, 2332],
              [-171, 2301],
              [-214, 2329],
              [-307, 2411],
              [-361, 2485],
              [-298, 2513],
              [-375, 2514],
              [-433, 2580],
              [-433, 2614],
              [-466, 2638],
              [-481, 2721],
              [-449, 2720],
              [-480, 2752],
              [-486, 2805],
              [-539, 2805],
              [-523, 2853],
              [-548, 2838],
              [-556, 2891],
              [-619, 2900],
              [-588, 2922],
              [-632, 3025],
              [-630, 3063],
              [-550, 3058],
              [-519, 3037],
              [-514, 2997],
              [-461, 2943],
              [-357, 2876],
              [-250, 2782],
              [-273, 2718],
              [-249, 2662],
              [-264, 2658],
              [-240, 2584],
              [-145, 2501],
              [-100, 2406],
              [-122, 2406],
              [-127, 2332]
            ]
          ],
          [
            [
              [-816, 3699],
              [-854, 3632],
              [-840, 3612],
              [-856, 3532],
              [-836, 3532],
              [-829, 3474],
              [-857, 3465],
              [-878, 3591],
              [-908, 3674],
              [-910, 3728],
              [-921, 3777],
              [-860, 3751],
              [-819, 3753],
              [-816, 3699]
            ]
          ],
          [
            [
              [-868, 4009],
              [-794, 3951],
              [-796, 3895],
              [-861, 3884],
              [-828, 3856],
              [-790, 3895],
              [-785, 3922],
              [-717, 3923],
              [-777, 3862],
              [-822, 3780],
              [-880, 3759],
              [-909, 3773],
              [-927, 3809],
              [-889, 3827],
              [-932, 3876],
              [-909, 3908],
              [-921, 3935],
              [-868, 4009]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.NU',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.36,
        'hc-middle-y': 0.66,
        'hc-key': 'ca-nu',
        'hc-a2': 'NU',
        labelrank: '2',
        hasc: 'CA.NU',
        'alt-name': null,
        'woe-id': '20069920',
        subregion: null,
        fips: 'CA10',
        'postal-code': 'NU',
        name: 'Nunavut',
        country: 'Canada',
        'type-en': 'Territory',
        region: 'Northern Canada',
        longitude: '-97.1443',
        'woe-name': 'Nunavut',
        latitude: '64.3853',
        'woe-label': 'Nunavut, CA, Canada',
        type: 'Territoire'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3649, 6454],
              [3647, 6477],
              [3621, 6452],
              [3590, 6452],
              [3561, 6502],
              [3545, 6474],
              [3466, 6519],
              [3436, 6529],
              [3411, 6579],
              [3401, 6627],
              [3423, 6698],
              [3388, 6740],
              [3401, 6803],
              [3392, 6846],
              [3423, 6875],
              [3449, 6850],
              [3458, 6894],
              [3423, 6906],
              [3459, 6963],
              [3465, 6999],
              [3505, 7014],
              [3470, 7003],
              [3454, 7127],
              [3413, 7194],
              [3415, 7268],
              [3396, 7375],
              [3398, 7396],
              [3424, 7405],
              [3451, 7392],
              [3416, 7434],
              [3418, 7461],
              [3448, 7485],
              [3511, 7509],
              [3566, 7507],
              [3603, 7480],
              [3645, 7495],
              [3681, 7495],
              [3735, 7480],
              [3686, 7314],
              [3667, 7228],
              [3637, 7192],
              [3567, 7202],
              [3518, 7191],
              [3538, 7179],
              [3572, 7127],
              [3553, 7092],
              [3539, 7024],
              [3511, 7015],
              [3529, 6942],
              [3539, 6972],
              [3574, 6970],
              [3570, 6944],
              [3637, 6886],
              [3652, 6843],
              [3656, 6767],
              [3700, 6739],
              [3735, 6688],
              [3747, 6653],
              [3759, 6678],
              [3783, 6637],
              [3748, 6623],
              [3730, 6634],
              [3709, 6607],
              [3741, 6614],
              [3755, 6602],
              [3736, 6566],
              [3695, 6521],
              [3743, 6520],
              [3784, 6486],
              [3807, 6530],
              [3836, 6500],
              [3870, 6511],
              [3908, 6494],
              [3907, 6450],
              [3833, 6451],
              [3877, 6416],
              [3912, 6368],
              [3905, 6351],
              [3919, 6306],
              [3915, 6272],
              [3940, 6262],
              [3949, 6233],
              [3966, 6267],
              [3978, 6329],
              [3965, 6417],
              [3983, 6466],
              [4014, 6469],
              [4037, 6439],
              [4105, 6391],
              [4145, 6292],
              [4139, 6261],
              [4113, 6291],
              [4098, 6269],
              [4133, 6164],
              [4216, 6088],
              [4231, 6064],
              [4264, 6075],
              [4271, 6113],
              [4296, 6110],
              [4278, 6176],
              [4310, 6267],
              [4301, 6326],
              [4307, 6348],
              [4293, 6416],
              [4315, 6430],
              [4361, 6435],
              [4328, 6449],
              [4349, 6477],
              [4332, 6493],
              [4365, 6502],
              [4292, 6524],
              [4264, 6577],
              [4269, 6601],
              [4253, 6618],
              [4259, 6664],
              [4282, 6654],
              [4292, 6676],
              [4331, 6685],
              [4382, 6669],
              [4368, 6689],
              [4395, 6687],
              [4388, 6666],
              [4464, 6682],
              [4444, 6706],
              [4470, 6709],
              [4471, 6676],
              [4488, 6646],
              [4435, 6640],
              [4511, 6635],
              [4529, 6613],
              [4596, 6610],
              [4608, 6590],
              [4579, 6539],
              [4633, 6524],
              [4639, 6494],
              [4595, 6433],
              [4557, 6433],
              [4548, 6413],
              [4582, 6408],
              [4586, 6370],
              [4615, 6369],
              [4624, 6318],
              [4693, 6277],
              [4721, 6247],
              [4729, 6142],
              [4695, 6127],
              [4690, 6077],
              [4665, 6022],
              [4634, 6010],
              [4625, 5961],
              [4600, 5954],
              [4580, 5989],
              [4545, 6004],
              [4539, 6047],
              [4530, 6018],
              [4497, 6048],
              [4495, 6068],
              [4455, 6051],
              [4531, 6012],
              [4530, 5991],
              [4558, 5972],
              [4598, 5919],
              [4574, 5914],
              [4547, 5934],
              [4509, 5928],
              [4539, 5901],
              [4458, 5902],
              [4430, 5958],
              [4396, 5935],
              [4353, 5936],
              [4319, 5900],
              [4340, 5879],
              [4414, 5863],
              [4410, 5833],
              [4379, 5796],
              [4382, 5758],
              [4321, 5653],
              [4272, 5643],
              [4205, 5685],
              [4177, 5693],
              [4089, 5744],
              [4059, 5726],
              [3929, 5717],
              [3977, 5695],
              [3967, 5719],
              [4071, 5707],
              [4120, 5676],
              [4172, 5621],
              [4355, 5640],
              [4370, 5622],
              [4338, 5483],
              [4320, 5471],
              [4319, 5397],
              [4258, 5335],
              [4199, 5360],
              [4229, 5323],
              [4175, 5342],
              [4147, 5376],
              [4139, 5345],
              [4156, 5313],
              [4130, 5306],
              [4147, 5280],
              [4127, 5229],
              [4095, 5237],
              [4091, 5186],
              [4041, 5221],
              [3988, 5231],
              [3918, 5234],
              [3947, 5220],
              [3917, 5178],
              [3975, 5228],
              [4025, 5185],
              [4085, 5175],
              [4110, 5106],
              [4097, 5075],
              [4077, 5074],
              [4042, 5032],
              [3970, 5041],
              [3941, 5019],
              [3994, 4996],
              [3996, 4969],
              [3948, 4965],
              [3949, 4937],
              [3925, 4944],
              [3931, 4903],
              [3897, 4877],
              [3914, 4865],
              [3893, 4834],
              [3906, 4802],
              [3850, 4821],
              [3891, 4789],
              [3823, 4709],
              [3842, 4682],
              [3813, 4679],
              [3828, 4658],
              [3800, 4574],
              [3789, 4504],
              [3766, 4500],
              [3783, 4469],
              [3772, 4382],
              [3772, 4382],
              [3772, 4382],
              [2984, 4342],
              [2984, 4342],
              [2988, 5267],
              [2964, 5273],
              [2382, 5413],
              [2315, 5435],
              [2284, 5466],
              [2197, 5603],
              [2035, 5627],
              [1467, 6320],
              [1465, 6325],
              [1562, 6653],
              [1583, 6612],
              [1694, 6540],
              [1731, 6484],
              [1881, 6400],
              [1861, 6436],
              [1892, 6441],
              [1957, 6399],
              [1991, 6356],
              [2026, 6278],
              [2012, 6247],
              [1936, 6269],
              [1950, 6246],
              [1910, 6253],
              [1913, 6214],
              [1875, 6203],
              [1903, 6168],
              [1930, 6165],
              [2002, 6124],
              [2120, 6100],
              [2130, 6113],
              [2194, 6097],
              [2257, 6110],
              [2325, 6154],
              [2346, 6076],
              [2400, 6070],
              [2412, 5988],
              [2424, 6039],
              [2443, 6025],
              [2480, 5965],
              [2485, 5912],
              [2465, 5912],
              [2459, 5873],
              [2527, 5754],
              [2503, 5810],
              [2490, 5905],
              [2521, 5858],
              [2525, 5892],
              [2546, 5872],
              [2532, 5917],
              [2517, 5917],
              [2512, 5988],
              [2519, 6010],
              [2489, 6055],
              [2484, 5972],
              [2473, 6020],
              [2497, 6090],
              [2519, 6101],
              [2507, 6142],
              [2543, 6128],
              [2568, 6145],
              [2599, 6137],
              [2614, 6167],
              [2626, 6145],
              [2629, 6189],
              [2687, 6201],
              [2698, 6249],
              [2625, 6228],
              [2615, 6181],
              [2602, 6205],
              [2571, 6176],
              [2539, 6197],
              [2509, 6181],
              [2528, 6156],
              [2470, 6159],
              [2464, 6195],
              [2434, 6190],
              [2485, 6262],
              [2566, 6272],
              [2651, 6311],
              [2692, 6299],
              [2713, 6266],
              [2715, 6224],
              [2704, 6197],
              [2755, 6155],
              [2778, 6155],
              [2786, 6110],
              [2836, 6106],
              [2864, 6116],
              [2912, 6083],
              [2928, 6058],
              [2965, 6037],
              [2993, 6052],
              [3031, 6027],
              [3054, 6047],
              [3078, 6043],
              [3098, 6065],
              [3206, 6056],
              [3224, 6039],
              [3295, 6063],
              [3263, 6094],
              [3275, 6124],
              [3318, 6053],
              [3370, 6023],
              [3363, 6041],
              [3399, 6063],
              [3348, 6113],
              [3319, 6088],
              [3291, 6105],
              [3295, 6142],
              [3260, 6185],
              [3301, 6173],
              [3339, 6189],
              [3318, 6228],
              [3377, 6214],
              [3399, 6189],
              [3395, 6170],
              [3426, 6177],
              [3444, 6163],
              [3421, 6119],
              [3491, 6185],
              [3474, 6080],
              [3479, 6035],
              [3465, 6048],
              [3459, 6000],
              [3493, 5995],
              [3481, 5951],
              [3497, 5948],
              [3523, 5983],
              [3537, 5968],
              [3518, 5936],
              [3544, 5951],
              [3564, 5898],
              [3519, 5888],
              [3473, 5895],
              [3524, 5848],
              [3501, 5882],
              [3570, 5883],
              [3560, 5939],
              [3572, 5969],
              [3548, 6004],
              [3540, 6043],
              [3519, 6057],
              [3532, 6139],
              [3581, 6134],
              [3619, 6186],
              [3627, 6216],
              [3685, 6281],
              [3659, 6273],
              [3664, 6329],
              [3634, 6355],
              [3625, 6301],
              [3583, 6296],
              [3580, 6343],
              [3614, 6368],
              [3598, 6387],
              [3600, 6427],
              [3627, 6433],
              [3649, 6454]
            ],
            [
              [3649, 6454],
              [3649, 6450],
              [3649, 6450],
              [3649, 6450],
              [3630, 6411],
              [3635, 6394],
              [3665, 6445],
              [3650, 6440],
              [3649, 6450],
              [3649, 6450],
              [3649, 6450],
              [3652, 6457],
              [3649, 6454]
            ]
          ],
          [
            [
              [5655, 3268],
              [5695, 3275],
              [5755, 3236],
              [5783, 3187],
              [5737, 3185],
              [5588, 3200],
              [5600, 3240],
              [5655, 3268]
            ]
          ],
          [
            [
              [5752, 3962],
              [5747, 4044],
              [5757, 4049],
              [5776, 3995],
              [5752, 3962]
            ]
          ],
          [
            [
              [6480, 5377],
              [6517, 5367],
              [6522, 5326],
              [6499, 5290],
              [6481, 5295],
              [6465, 5368],
              [6480, 5377]
            ]
          ],
          [
            [
              [6625, 5763],
              [6589, 5780],
              [6603, 5791],
              [6665, 5761],
              [6687, 5735],
              [6692, 5693],
              [6604, 5707],
              [6632, 5749],
              [6625, 5763]
            ]
          ],
          [
            [
              [5237, 5243],
              [5263, 5222],
              [5276, 5166],
              [5264, 5068],
              [5208, 5093],
              [5187, 5122],
              [5179, 5167],
              [5197, 5236],
              [5237, 5243]
            ]
          ],
          [
            [
              [6565, 5924],
              [6590, 5940],
              [6593, 5899],
              [6559, 5890],
              [6565, 5924]
            ]
          ],
          [
            [
              [5999, 5679],
              [6033, 5678],
              [6079, 5658],
              [6069, 5637],
              [6031, 5626],
              [5957, 5670],
              [5999, 5679]
            ]
          ],
          [
            [
              [5250, 5507],
              [5322, 5521],
              [5352, 5495],
              [5353, 5474],
              [5325, 5440],
              [5247, 5482],
              [5250, 5507]
            ]
          ],
          [
            [
              [5352, 5587],
              [5400, 5582],
              [5423, 5568],
              [5417, 5542],
              [5388, 5540],
              [5334, 5562],
              [5352, 5587]
            ]
          ],
          [
            [
              [4486, 5855],
              [4502, 5851],
              [4554, 5779],
              [4546, 5759],
              [4500, 5793],
              [4486, 5855]
            ]
          ],
          [
            [
              [4546, 5887],
              [4614, 5861],
              [4611, 5837],
              [4640, 5821],
              [4669, 5827],
              [4661, 5805],
              [4623, 5806],
              [4625, 5824],
              [4584, 5817],
              [4578, 5847],
              [4551, 5863],
              [4546, 5887]
            ]
          ],
          [
            [
              [5217, 6582],
              [5292, 6589],
              [5310, 6551],
              [5234, 6517],
              [5209, 6525],
              [5182, 6563],
              [5217, 6582]
            ]
          ],
          [
            [
              [4278, 6232],
              [4271, 6183],
              [4248, 6192],
              [4222, 6249],
              [4234, 6307],
              [4262, 6290],
              [4278, 6232]
            ]
          ],
          [
            [
              [2786, 6192],
              [2744, 6226],
              [2775, 6231],
              [2791, 6215],
              [2786, 6192]
            ]
          ],
          [
            [
              [5128, 6658],
              [5155, 6614],
              [5092, 6635],
              [5088, 6682],
              [5128, 6658]
            ]
          ],
          [
            [
              [3010, 6272],
              [3018, 6247],
              [3003, 6225],
              [2964, 6250],
              [2990, 6280],
              [3010, 6272]
            ]
          ],
          [
            [
              [3136, 6317],
              [3139, 6353],
              [3151, 6331],
              [3138, 6277],
              [3124, 6259],
              [3102, 6275],
              [3101, 6319],
              [3136, 6317]
            ]
          ],
          [
            [
              [4796, 6725],
              [4821, 6713],
              [4809, 6691],
              [4805, 6616],
              [4781, 6587],
              [4759, 6602],
              [4764, 6641],
              [4780, 6651],
              [4781, 6704],
              [4796, 6725]
            ]
          ],
          [
            [
              [4897, 6770],
              [4928, 6776],
              [4922, 6729],
              [4930, 6713],
              [4903, 6707],
              [4877, 6762],
              [4897, 6770]
            ]
          ],
          [
            [
              [3408, 6459],
              [3446, 6463],
              [3451, 6416],
              [3419, 6440],
              [3408, 6459]
            ]
          ],
          [
            [
              [3482, 6476],
              [3507, 6459],
              [3507, 6429],
              [3485, 6412],
              [3480, 6464],
              [3462, 6419],
              [3463, 6470],
              [3482, 6476]
            ]
          ],
          [
            [
              [4809, 6799],
              [4808, 6774],
              [4784, 6743],
              [4758, 6738],
              [4768, 6775],
              [4791, 6808],
              [4809, 6799]
            ]
          ],
          [
            [
              [4675, 6783],
              [4709, 6768],
              [4673, 6731],
              [4677, 6717],
              [4646, 6711],
              [4604, 6743],
              [4636, 6765],
              [4660, 6756],
              [4675, 6783]
            ]
          ],
          [
            [
              [4120, 6693],
              [4146, 6699],
              [4165, 6679],
              [4120, 6663],
              [4093, 6683],
              [4120, 6693]
            ]
          ],
          [
            [
              [3091, 6694],
              [3105, 6694],
              [3126, 6646],
              [3093, 6665],
              [3091, 6694]
            ]
          ],
          [
            [
              [5109, 7263],
              [5144, 7269],
              [5150, 7245],
              [5113, 7206],
              [5095, 7225],
              [5109, 7263]
            ]
          ],
          [
            [
              [3339, 7251],
              [3353, 7238],
              [3331, 7208],
              [3314, 7241],
              [3334, 7268],
              [3339, 7251]
            ]
          ],
          [
            [
              [2896, 7734],
              [2905, 7708],
              [2888, 7683],
              [2866, 7673],
              [2827, 7699],
              [2843, 7749],
              [2875, 7768],
              [2896, 7734]
            ]
          ],
          [
            [
              [3322, 7828],
              [3345, 7809],
              [3330, 7784],
              [3313, 7784],
              [3294, 7758],
              [3281, 7790],
              [3322, 7828]
            ]
          ],
          [
            [
              [2994, 7889],
              [2957, 7841],
              [2923, 7839],
              [2940, 7874],
              [2986, 7894],
              [2994, 7889]
            ]
          ],
          [
            [
              [3431, 7865],
              [3412, 7859],
              [3393, 7901],
              [3414, 7916],
              [3431, 7865]
            ]
          ],
          [
            [
              [4241, 8139],
              [4255, 8134],
              [4246, 8104],
              [4270, 8083],
              [4247, 8079],
              [4245, 8059],
              [4224, 8068],
              [4241, 8139]
            ]
          ],
          [
            [
              [3087, 8061],
              [3034, 8024],
              [3016, 8031],
              [3053, 8065],
              [3087, 8061]
            ]
          ],
          [
            [
              [3656, 8074],
              [3639, 8063],
              [3603, 8110],
              [3602, 8128],
              [3628, 8144],
              [3647, 8127],
              [3644, 8094],
              [3656, 8074]
            ]
          ],
          [
            [
              [3255, 9011],
              [3272, 9007],
              [3269, 8989],
              [3230, 8998],
              [3255, 9011]
            ]
          ],
          [
            [
              [5497, 7102],
              [5495, 7097],
              [5494, 7102],
              [5494, 7102],
              [5494, 7102],
              [5497, 7102],
              [5497, 7102]
            ]
          ],
          [
            [
              [3199, 7451],
              [3262, 7474],
              [3268, 7463],
              [3239, 7418],
              [3189, 7399],
              [3157, 7421],
              [3199, 7451]
            ]
          ],
          [
            [
              [2888, 7884],
              [2974, 7916],
              [2980, 7910],
              [2979, 7898],
              [2904, 7871],
              [2888, 7884]
            ]
          ],
          [
            [
              [2872, 7947],
              [2959, 7968],
              [2964, 7958],
              [2969, 7932],
              [2952, 7914],
              [2898, 7905],
              [2868, 7916],
              [2872, 7947]
            ]
          ],
          [
            [
              [2874, 8051],
              [2896, 8040],
              [2941, 8003],
              [2926, 7972],
              [2869, 7973],
              [2869, 8006],
              [2857, 8037],
              [2874, 8051]
            ]
          ],
          [
            [
              [3551, 8323],
              [3580, 8321],
              [3616, 8287],
              [3625, 8257],
              [3608, 8226],
              [3562, 8242],
              [3544, 8263],
              [3538, 8311],
              [3551, 8323]
            ]
          ],
          [
            [
              [2827, 8298],
              [2849, 8254],
              [2847, 8226],
              [2861, 8226],
              [2876, 8200],
              [2873, 8164],
              [2857, 8155],
              [2819, 8202],
              [2798, 8304],
              [2827, 8298]
            ]
          ],
          [
            [
              [3039, 8321],
              [3053, 8299],
              [3022, 8295],
              [3010, 8283],
              [2978, 8296],
              [2981, 8332],
              [3017, 8333],
              [3039, 8321]
            ]
          ],
          [
            [
              [3093, 8867],
              [3107, 8858],
              [3120, 8864],
              [3139, 8825],
              [3143, 8783],
              [3138, 8755],
              [3116, 8774],
              [3103, 8807],
              [3083, 8801],
              [3077, 8838],
              [3093, 8867]
            ]
          ],
          [
            [
              [3427, 8259],
              [3405, 8251],
              [3385, 8257],
              [3302, 8249],
              [3284, 8275],
              [3285, 8301],
              [3301, 8315],
              [3322, 8329],
              [3326, 8314],
              [3347, 8327],
              [3413, 8332],
              [3434, 8321],
              [3427, 8259]
            ]
          ],
          [
            [
              [5497, 7102],
              [5511, 7134],
              [5529, 7125],
              [5525, 7096],
              [5497, 7102],
              [5497, 7102]
            ]
          ],
          [
            [
              [2454, 7126],
              [2467, 7123],
              [2455, 7135],
              [2456, 7141],
              [2470, 7135],
              [2459, 7164],
              [2461, 7182],
              [2475, 7185],
              [2462, 7192],
              [2469, 7244],
              [2483, 7218],
              [2549, 7139],
              [2542, 7094],
              [2555, 7045],
              [2550, 7009],
              [2565, 6999],
              [2555, 6966],
              [2573, 6927],
              [2591, 6925],
              [2605, 6956],
              [2627, 6961],
              [2628, 6984],
              [2597, 7039],
              [2604, 7071],
              [2591, 7124],
              [2600, 7136],
              [2590, 7179],
              [2594, 7280],
              [2613, 7274],
              [2603, 7313],
              [2629, 7304],
              [2659, 7272],
              [2680, 7297],
              [2718, 7243],
              [2743, 7224],
              [2771, 7173],
              [2771, 7097],
              [2792, 7033],
              [2785, 7019],
              [2826, 6902],
              [2831, 6849],
              [2815, 6841],
              [2803, 6796],
              [2840, 6745],
              [2849, 6711],
              [2909, 6656],
              [2910, 6694],
              [2930, 6657],
              [2997, 6601],
              [3016, 6610],
              [3029, 6566],
              [3064, 6585],
              [3080, 6499],
              [3073, 6467],
              [3045, 6470],
              [3033, 6518],
              [3018, 6463],
              [2979, 6520],
              [2966, 6489],
              [2948, 6485],
              [2953, 6445],
              [2932, 6439],
              [2882, 6478],
              [2876, 6459],
              [2927, 6406],
              [2956, 6426],
              [2988, 6427],
              [2979, 6398],
              [3012, 6355],
              [2995, 6313],
              [2911, 6276],
              [2876, 6274],
              [2797, 6311],
              [2785, 6294],
              [2731, 6317],
              [2761, 6336],
              [2686, 6369],
              [2645, 6374],
              [2655, 6421],
              [2636, 6445],
              [2604, 6416],
              [2605, 6388],
              [2569, 6344],
              [2519, 6329],
              [2472, 6335],
              [2434, 6294],
              [2378, 6278],
              [2299, 6283],
              [2287, 6255],
              [2256, 6257],
              [2285, 6277],
              [2137, 6283],
              [2122, 6275],
              [2078, 6311],
              [2062, 6361],
              [2080, 6413],
              [2075, 6448],
              [2025, 6478],
              [1962, 6481],
              [1904, 6506],
              [1862, 6552],
              [1854, 6597],
              [1870, 6589],
              [1845, 6654],
              [1852, 6678],
              [2167, 6613],
              [2163, 6576],
              [2195, 6575],
              [2197, 6608],
              [2386, 6581],
              [2454, 7126]
            ]
          ],
          [
            [
              [2552, 7904],
              [2586, 7921],
              [2596, 7943],
              [2578, 7973],
              [2561, 7976],
              [2569, 8035],
              [2597, 8065],
              [2621, 8107],
              [2644, 8114],
              [2656, 8071],
              [2641, 8063],
              [2649, 8019],
              [2667, 7978],
              [2639, 7924],
              [2675, 7926],
              [2684, 7904],
              [2669, 7889],
              [2716, 7882],
              [2723, 7853],
              [2726, 7893],
              [2744, 7919],
              [2789, 7900],
              [2802, 7876],
              [2806, 7823],
              [2783, 7786],
              [2786, 7754],
              [2760, 7703],
              [2762, 7687],
              [2717, 7678],
              [2701, 7661],
              [2671, 7668],
              [2663, 7694],
              [2639, 7670],
              [2617, 7667],
              [2597, 7705],
              [2547, 7662],
              [2522, 7664],
              [2542, 7820],
              [2603, 7801],
              [2610, 7830],
              [2598, 7861],
              [2551, 7896],
              [2552, 7904]
            ]
          ],
          [
            [
              [2616, 8406],
              [2635, 8393],
              [2611, 8367],
              [2616, 8406]
            ]
          ],
          [
            [
              [2633, 8543],
              [2653, 8517],
              [2661, 8486],
              [2649, 8451],
              [2622, 8460],
              [2632, 8539],
              [2633, 8543]
            ]
          ],
          [
            [
              [6838, 5533],
              [6840, 5524],
              [6792, 5531],
              [6809, 5549],
              [6842, 5539],
              [6838, 5533]
            ]
          ],
          [
            [
              [5655, 3947],
              [5676, 3971],
              [5682, 4031],
              [5697, 4051],
              [5729, 3989],
              [5717, 3986],
              [5707, 3900],
              [5685, 3896],
              [5676, 3943],
              [5659, 3871],
              [5640, 3882],
              [5655, 3947]
            ]
          ],
          [
            [
              [6463, 5976],
              [6518, 5943],
              [6542, 5909],
              [6516, 5904],
              [6490, 5940],
              [6364, 5922],
              [6333, 5943],
              [6323, 5921],
              [6223, 5950],
              [6174, 5974],
              [6214, 5933],
              [6153, 5950],
              [6083, 5955],
              [6064, 5936],
              [6089, 5917],
              [6184, 5877],
              [6194, 5898],
              [6227, 5871],
              [6263, 5873],
              [6336, 5846],
              [6352, 5826],
              [6370, 5843],
              [6431, 5820],
              [6472, 5792],
              [6497, 5795],
              [6499, 5749],
              [6529, 5737],
              [6505, 5713],
              [6446, 5717],
              [6413, 5703],
              [6379, 5711],
              [6259, 5670],
              [6203, 5672],
              [6125, 5699],
              [6132, 5727],
              [6079, 5710],
              [6057, 5687],
              [6023, 5698],
              [5953, 5691],
              [5884, 5704],
              [5864, 5736],
              [5820, 5739],
              [5862, 5754],
              [5884, 5799],
              [5855, 5791],
              [5846, 5816],
              [5808, 5789],
              [5762, 5835],
              [5760, 5803],
              [5735, 5797],
              [5691, 5828],
              [5685, 5849],
              [5640, 5869],
              [5654, 5830],
              [5600, 5897],
              [5606, 5850],
              [5583, 5898],
              [5557, 5896],
              [5576, 5838],
              [5536, 5916],
              [5514, 5867],
              [5512, 5822],
              [5395, 5829],
              [5386, 5750],
              [5345, 5725],
              [5351, 5710],
              [5303, 5717],
              [5288, 5697],
              [5233, 5706],
              [5181, 5753],
              [5179, 5790],
              [5162, 5817],
              [5171, 5843],
              [5215, 5895],
              [5188, 5914],
              [5184, 5944],
              [5253, 5959],
              [5347, 5951],
              [5385, 5934],
              [5380, 5903],
              [5419, 5865],
              [5426, 5874],
              [5398, 5923],
              [5368, 5949],
              [5322, 5966],
              [5390, 5979],
              [5387, 6011],
              [5434, 6017],
              [5463, 6078],
              [5518, 6084],
              [5479, 6130],
              [5437, 6143],
              [5373, 6186],
              [5419, 6303],
              [5434, 6366],
              [5425, 6426],
              [5453, 6458],
              [5450, 6494],
              [5431, 6499],
              [5407, 6536],
              [5373, 6562],
              [5368, 6583],
              [5331, 6598],
              [5298, 6657],
              [5237, 6648],
              [5211, 6661],
              [5206, 6718],
              [5165, 6717],
              [5203, 6691],
              [5182, 6672],
              [5153, 6680],
              [5136, 6663],
              [5125, 6686],
              [5151, 6682],
              [5115, 6731],
              [5088, 6731],
              [5101, 6766],
              [5077, 6746],
              [5081, 6718],
              [5044, 6735],
              [5047, 6703],
              [5009, 6643],
              [4988, 6631],
              [4979, 6674],
              [4960, 6699],
              [4972, 6714],
              [5008, 6717],
              [5028, 6744],
              [5006, 6783],
              [4917, 6808],
              [4867, 6813],
              [4890, 6833],
              [4877, 6854],
              [4829, 6849],
              [4818, 6836],
              [4790, 6911],
              [4769, 6922],
              [4737, 6899],
              [4694, 6940],
              [4664, 6948],
              [4666, 6926],
              [4643, 6930],
              [4641, 6905],
              [4688, 6906],
              [4733, 6849],
              [4726, 6818],
              [4673, 6789],
              [4646, 6811],
              [4612, 6802],
              [4554, 6808],
              [4503, 6797],
              [4534, 6779],
              [4552, 6784],
              [4599, 6742],
              [4591, 6730],
              [4524, 6769],
              [4468, 6784],
              [4519, 6758],
              [4495, 6725],
              [4472, 6722],
              [4416, 6744],
              [4375, 6718],
              [4296, 6710],
              [4241, 6719],
              [4210, 6709],
              [4256, 6695],
              [4216, 6687],
              [4147, 6726],
              [4140, 6751],
              [4120, 6740],
              [4101, 6768],
              [4088, 6748],
              [4112, 6728],
              [4052, 6726],
              [4052, 6704],
              [4017, 6718],
              [4046, 6721],
              [3979, 6741],
              [3906, 6827],
              [3922, 6838],
              [3890, 6866],
              [3924, 6859],
              [3957, 6871],
              [3984, 6854],
              [4053, 6867],
              [4056, 6881],
              [4017, 6903],
              [4006, 6927],
              [3991, 6914],
              [3863, 6915],
              [3844, 6941],
              [3839, 6975],
              [3846, 7011],
              [3819, 7041],
              [3821, 7076],
              [3845, 7102],
              [3815, 7118],
              [3814, 7190],
              [3826, 7202],
              [3819, 7241],
              [3839, 7236],
              [3826, 7300],
              [3834, 7349],
              [3862, 7418],
              [3893, 7469],
              [3952, 7512],
              [3994, 7524],
              [4052, 7528],
              [4073, 7518],
              [4070, 7499],
              [4040, 7455],
              [4023, 7402],
              [4006, 7285],
              [4015, 7248],
              [4046, 7223],
              [4057, 7200],
              [4053, 7155],
              [4066, 7113],
              [4097, 7071],
              [4155, 7021],
              [4197, 7012],
              [4212, 6981],
              [4190, 6975],
              [4170, 6948],
              [4140, 6939],
              [4129, 6914],
              [4090, 6887],
              [4127, 6897],
              [4156, 6937],
              [4219, 6956],
              [4224, 6903],
              [4237, 6918],
              [4216, 6984],
              [4224, 7029],
              [4199, 7071],
              [4163, 7059],
              [4134, 7080],
              [4128, 7105],
              [4093, 7125],
              [4124, 7145],
              [4115, 7185],
              [4145, 7190],
              [4216, 7155],
              [4149, 7200],
              [4140, 7216],
              [4102, 7227],
              [4080, 7261],
              [4067, 7318],
              [4072, 7339],
              [4098, 7339],
              [4165, 7322],
              [4093, 7352],
              [4069, 7350],
              [4085, 7382],
              [4136, 7375],
              [4175, 7380],
              [4126, 7385],
              [4080, 7400],
              [4093, 7440],
              [4130, 7412],
              [4104, 7445],
              [4196, 7550],
              [4276, 7570],
              [4306, 7538],
              [4333, 7477],
              [4368, 7470],
              [4386, 7419],
              [4424, 7386],
              [4418, 7347],
              [4433, 7305],
              [4415, 7257],
              [4449, 7242],
              [4420, 7232],
              [4445, 7215],
              [4464, 7237],
              [4449, 7263],
              [4468, 7347],
              [4495, 7316],
              [4511, 7335],
              [4541, 7317],
              [4550, 7275],
              [4546, 7248],
              [4583, 7248],
              [4562, 7267],
              [4550, 7310],
              [4560, 7343],
              [4618, 7338],
              [4556, 7359],
              [4550, 7395],
              [4589, 7450],
              [4634, 7465],
              [4658, 7449],
              [4761, 7457],
              [4798, 7414],
              [4787, 7349],
              [4802, 7385],
              [4859, 7397],
              [4876, 7378],
              [4880, 7343],
              [4838, 7296],
              [4871, 7299],
              [4870, 7250],
              [4895, 7245],
              [4875, 7274],
              [4878, 7304],
              [4907, 7345],
              [4928, 7351],
              [4926, 7283],
              [4949, 7310],
              [4954, 7284],
              [5009, 7267],
              [5006, 7299],
              [5003, 7278],
              [4987, 7280],
              [4965, 7311],
              [4982, 7321],
              [4988, 7295],
              [4990, 7319],
              [5005, 7311],
              [5003, 7328],
              [4980, 7331],
              [5004, 7362],
              [5080, 7362],
              [5134, 7327],
              [5133, 7278],
              [5093, 7261],
              [5092, 7209],
              [5105, 7186],
              [5159, 7244],
              [5156, 7280],
              [5171, 7307],
              [5207, 7281],
              [5210, 7229],
              [5194, 7186],
              [5172, 7184],
              [5171, 7153],
              [5187, 7116],
              [5177, 7176],
              [5203, 7180],
              [5233, 7091],
              [5207, 7205],
              [5252, 7290],
              [5264, 7260],
              [5242, 7218],
              [5273, 7229],
              [5284, 7280],
              [5321, 7287],
              [5384, 7286],
              [5399, 7240],
              [5347, 7181],
              [5324, 7123],
              [5341, 7126],
              [5328, 7094],
              [5356, 7116],
              [5344, 7152],
              [5402, 7200],
              [5413, 7191],
              [5391, 7096],
              [5428, 7158],
              [5445, 7203],
              [5425, 7217],
              [5432, 7247],
              [5485, 7231],
              [5528, 7205],
              [5560, 7167],
              [5512, 7153],
              [5488, 7121],
              [5494, 7102],
              [5494, 7102],
              [5494, 7102],
              [5489, 7103],
              [5461, 7090],
              [5437, 7042],
              [5476, 7084],
              [5529, 7081],
              [5546, 7128],
              [5566, 7127],
              [5560, 7101],
              [5582, 7112],
              [5625, 7105],
              [5651, 7080],
              [5583, 7039],
              [5533, 7045],
              [5472, 7023],
              [5548, 7026],
              [5523, 7012],
              [5594, 7010],
              [5580, 6985],
              [5619, 6959],
              [5518, 6915],
              [5544, 6913],
              [5611, 6930],
              [5597, 6900],
              [5667, 6922],
              [5721, 6926],
              [5722, 6902],
              [5750, 6897],
              [5782, 6862],
              [5769, 6908],
              [5786, 6927],
              [5817, 6865],
              [5830, 6890],
              [5856, 6850],
              [5848, 6884],
              [5872, 6906],
              [5883, 6892],
              [5899, 6938],
              [5924, 6936],
              [5913, 6892],
              [5931, 6873],
              [5941, 6906],
              [5973, 6911],
              [6046, 6890],
              [6038, 6869],
              [6062, 6844],
              [6009, 6790],
              [6055, 6820],
              [6031, 6783],
              [6073, 6822],
              [6078, 6870],
              [6139, 6874],
              [6130, 6845],
              [6153, 6796],
              [6174, 6832],
              [6201, 6805],
              [6198, 6843],
              [6247, 6816],
              [6214, 6847],
              [6211, 6876],
              [6250, 6884],
              [6326, 6857],
              [6331, 6807],
              [6309, 6776],
              [6353, 6794],
              [6329, 6755],
              [6295, 6761],
              [6260, 6748],
              [6300, 6739],
              [6293, 6714],
              [6331, 6721],
              [6362, 6706],
              [6332, 6674],
              [6361, 6653],
              [6367, 6615],
              [6317, 6573],
              [6273, 6600],
              [6312, 6560],
              [6302, 6519],
              [6357, 6491],
              [6380, 6422],
              [6336, 6430],
              [6327, 6456],
              [6297, 6421],
              [6258, 6455],
              [6276, 6405],
              [6220, 6437],
              [6165, 6456],
              [6162, 6479],
              [6139, 6471],
              [6119, 6519],
              [6144, 6565],
              [6133, 6582],
              [6108, 6530],
              [6073, 6501],
              [6050, 6529],
              [5984, 6550],
              [5958, 6543],
              [5933, 6569],
              [5893, 6547],
              [5938, 6514],
              [5920, 6499],
              [5864, 6509],
              [5897, 6475],
              [5966, 6459],
              [5977, 6439],
              [5922, 6400],
              [5898, 6432],
              [5861, 6446],
              [5842, 6432],
              [5900, 6414],
              [5874, 6410],
              [5911, 6367],
              [5954, 6353],
              [5958, 6315],
              [5978, 6382],
              [6001, 6380],
              [6002, 6344],
              [6035, 6355],
              [6063, 6304],
              [6059, 6342],
              [6084, 6292],
              [6102, 6290],
              [6140, 6249],
              [6114, 6293],
              [6176, 6286],
              [6191, 6249],
              [6190, 6298],
              [6234, 6292],
              [6249, 6255],
              [6259, 6303],
              [6278, 6285],
              [6267, 6254],
              [6313, 6253],
              [6313, 6221],
              [6288, 6215],
              [6357, 6190],
              [6351, 6174],
              [6401, 6193],
              [6401, 6158],
              [6417, 6184],
              [6425, 6160],
              [6450, 6171],
              [6509, 6093],
              [6441, 6152],
              [6401, 6151],
              [6401, 6142],
              [6451, 6139],
              [6494, 6065],
              [6466, 6067],
              [6415, 6115],
              [6413, 6091],
              [6527, 5997],
              [6510, 5975],
              [6463, 5976]
            ]
          ],
          [
            [
              [4873, 5097],
              [4841, 5064],
              [4797, 5130],
              [4819, 5184],
              [4830, 5240],
              [4852, 5227],
              [4883, 5257],
              [4941, 5281],
              [4968, 5279],
              [4974, 5237],
              [4948, 5196],
              [4921, 5125],
              [4892, 5085],
              [4873, 5097]
            ]
          ],
          [
            [
              [5159, 6564],
              [5161, 6527],
              [5181, 6503],
              [5203, 6449],
              [5194, 6399],
              [5164, 6362],
              [5078, 6324],
              [5048, 6355],
              [5014, 6409],
              [5010, 6446],
              [5018, 6542],
              [5042, 6569],
              [5096, 6587],
              [5138, 6586],
              [5159, 6564]
            ]
          ],
          [
            [
              [2732, 7273],
              [2705, 7318],
              [2673, 7336],
              [2704, 7385],
              [2796, 7389],
              [2836, 7345],
              [2828, 7288],
              [2777, 7186],
              [2732, 7273]
            ]
          ],
          [
            [
              [4728, 5458],
              [4747, 5406],
              [4716, 5365],
              [4695, 5360],
              [4684, 5286],
              [4629, 5229],
              [4588, 5245],
              [4573, 5325],
              [4548, 5342],
              [4505, 5316],
              [4469, 5310],
              [4454, 5285],
              [4424, 5283],
              [4416, 5314],
              [4433, 5363],
              [4490, 5416],
              [4464, 5456],
              [4444, 5516],
              [4451, 5595],
              [4431, 5669],
              [4427, 5775],
              [4458, 5820],
              [4465, 5792],
              [4490, 5801],
              [4513, 5763],
              [4494, 5742],
              [4520, 5729],
              [4554, 5683],
              [4562, 5748],
              [4609, 5725],
              [4621, 5700],
              [4687, 5702],
              [4716, 5667],
              [4770, 5645],
              [4802, 5651],
              [4872, 5614],
              [4894, 5562],
              [4913, 5560],
              [4884, 5503],
              [4937, 5534],
              [4985, 5535],
              [4978, 5559],
              [5022, 5538],
              [5017, 5516],
              [5064, 5514],
              [5044, 5489],
              [5012, 5414],
              [4898, 5434],
              [4860, 5421],
              [4861, 5460],
              [4837, 5480],
              [4790, 5462],
              [4780, 5513],
              [4736, 5482],
              [4728, 5458]
            ]
          ],
          [
            [
              [3459, 6391],
              [3483, 6316],
              [3535, 6313],
              [3513, 6272],
              [3489, 6281],
              [3455, 6222],
              [3437, 6214],
              [3394, 6234],
              [3359, 6228],
              [3334, 6252],
              [3304, 6256],
              [3292, 6288],
              [3271, 6270],
              [3243, 6288],
              [3232, 6314],
              [3218, 6286],
              [3184, 6325],
              [3191, 6349],
              [3229, 6355],
              [3275, 6396],
              [3257, 6423],
              [3260, 6455],
              [3304, 6427],
              [3274, 6460],
              [3283, 6504],
              [3305, 6527],
              [3356, 6486],
              [3390, 6444],
              [3459, 6391]
            ]
          ],
          [
            [
              [4645, 7554],
              [4656, 7522],
              [4672, 7519],
              [4663, 7495],
              [4590, 7481],
              [4542, 7467],
              [4491, 7414],
              [4465, 7406],
              [4435, 7416],
              [4406, 7454],
              [4393, 7494],
              [4353, 7491],
              [4334, 7525],
              [4319, 7585],
              [4337, 7604],
              [4407, 7595],
              [4483, 7631],
              [4551, 7618],
              [4574, 7590],
              [4599, 7587],
              [4614, 7561],
              [4645, 7554]
            ]
          ],
          [
            [
              [3048, 7063],
              [3033, 7042],
              [3006, 7061],
              [2998, 7100],
              [2954, 7137],
              [2945, 7171],
              [2964, 7222],
              [2993, 7231],
              [3026, 7188],
              [3043, 7150],
              [3099, 7155],
              [3100, 7186],
              [3125, 7206],
              [3112, 7244],
              [3087, 7247],
              [3104, 7287],
              [3070, 7273],
              [3020, 7324],
              [3045, 7350],
              [3065, 7349],
              [3080, 7321],
              [3089, 7349],
              [3057, 7367],
              [3067, 7401],
              [3096, 7404],
              [3121, 7387],
              [3109, 7422],
              [3134, 7426],
              [3141, 7406],
              [3173, 7383],
              [3243, 7404],
              [3254, 7424],
              [3295, 7417],
              [3316, 7390],
              [3315, 7365],
              [3289, 7342],
              [3309, 7312],
              [3273, 7290],
              [3236, 7229],
              [3235, 7199],
              [3260, 7230],
              [3309, 7214],
              [3310, 7190],
              [3328, 7174],
              [3343, 7202],
              [3368, 7147],
              [3382, 7099],
              [3359, 7073],
              [3367, 7061],
              [3375, 6966],
              [3347, 6957],
              [3340, 6933],
              [3315, 6912],
              [3261, 6918],
              [3275, 6890],
              [3264, 6862],
              [3230, 6830],
              [3213, 6852],
              [3192, 6846],
              [3178, 6889],
              [3144, 6958],
              [3132, 6960],
              [3089, 7031],
              [3067, 7028],
              [3048, 7063]
            ]
          ],
          [
            [
              [3320, 7723],
              [3348, 7770],
              [3353, 7796],
              [3401, 7834],
              [3430, 7828],
              [3491, 7757],
              [3488, 7743],
              [3507, 7672],
              [3502, 7618],
              [3435, 7605],
              [3412, 7616],
              [3397, 7641],
              [3361, 7642],
              [3330, 7661],
              [3315, 7676],
              [3320, 7723]
            ]
          ],
          [
            [
              [3034, 7799],
              [3029, 7805],
              [2962, 7780],
              [2959, 7822],
              [2984, 7832],
              [2984, 7865],
              [3008, 7874],
              [3034, 7845],
              [3003, 7915],
              [3032, 7953],
              [2993, 7946],
              [2988, 7963],
              [3009, 8001],
              [3030, 7996],
              [3048, 7974],
              [3048, 7950],
              [3090, 7911],
              [3102, 7877],
              [3120, 7886],
              [3097, 7927],
              [3126, 7925],
              [3109, 7944],
              [3082, 7950],
              [3106, 7967],
              [3090, 7985],
              [3071, 7983],
              [3053, 8012],
              [3091, 8046],
              [3125, 8044],
              [3153, 8003],
              [3164, 8042],
              [3232, 8014],
              [3228, 7976],
              [3246, 7939],
              [3241, 7891],
              [3246, 7872],
              [3227, 7843],
              [3260, 7830],
              [3260, 7793],
              [3270, 7767],
              [3242, 7804],
              [3227, 7739],
              [3257, 7708],
              [3234, 7698],
              [3231, 7678],
              [3153, 7666],
              [3154, 7697],
              [3137, 7663],
              [3096, 7670],
              [3090, 7721],
              [3113, 7720],
              [3068, 7748],
              [3089, 7754],
              [3071, 7767],
              [3110, 7772],
              [3096, 7788],
              [3122, 7793],
              [3122, 7818],
              [3172, 7833],
              [3080, 7816],
              [3034, 7799]
            ]
          ],
          [
            [
              [3746, 7836],
              [3753, 7850],
              [3739, 7877],
              [3755, 7891],
              [3784, 7854],
              [3805, 7884],
              [3823, 7867],
              [3824, 7896],
              [3888, 7867],
              [3879, 7851],
              [3922, 7875],
              [3898, 7888],
              [3924, 7915],
              [3940, 7914],
              [3951, 7936],
              [3978, 7936],
              [4012, 7993],
              [4052, 7984],
              [4086, 8019],
              [4156, 8025],
              [4155, 7997],
              [4197, 8010],
              [4235, 7990],
              [4219, 7970],
              [4258, 7985],
              [4283, 7949],
              [4281, 7923],
              [4246, 7877],
              [4265, 7870],
              [4295, 7889],
              [4317, 7862],
              [4277, 7820],
              [4292, 7792],
              [4275, 7772],
              [4230, 7757],
              [4210, 7726],
              [4138, 7726],
              [4108, 7784],
              [4079, 7790],
              [4100, 7770],
              [4103, 7722],
              [4063, 7694],
              [4000, 7675],
              [3989, 7682],
              [3954, 7661],
              [3911, 7666],
              [3926, 7652],
              [3811, 7633],
              [3806, 7692],
              [3792, 7722],
              [3783, 7665],
              [3773, 7694],
              [3769, 7650],
              [3724, 7624],
              [3654, 7651],
              [3662, 7695],
              [3641, 7654],
              [3652, 7634],
              [3627, 7633],
              [3592, 7659],
              [3575, 7739],
              [3551, 7753],
              [3552, 7822],
              [3565, 7845],
              [3546, 7910],
              [3517, 7935],
              [3513, 7957],
              [3479, 8011],
              [3431, 7979],
              [3393, 7988],
              [3377, 7965],
              [3364, 7979],
              [3387, 7993],
              [3333, 8001],
              [3319, 8036],
              [3292, 8065],
              [3271, 8067],
              [3299, 8093],
              [3273, 8105],
              [3270, 8132],
              [3322, 8157],
              [3353, 8144],
              [3389, 8140],
              [3412, 8123],
              [3433, 8133],
              [3464, 8098],
              [3463, 8031],
              [3474, 8070],
              [3495, 8066],
              [3558, 8098],
              [3609, 8076],
              [3617, 8055],
              [3569, 8058],
              [3569, 8044],
              [3621, 8042],
              [3687, 8028],
              [3688, 8001],
              [3588, 7979],
              [3649, 7967],
              [3645, 7958],
              [3600, 7951],
              [3614, 7927],
              [3618, 7945],
              [3658, 7938],
              [3666, 7955],
              [3715, 7916],
              [3718, 7879],
              [3746, 7836]
            ]
          ],
          [
            [
              [3302, 8349],
              [3258, 8337],
              [3253, 8318],
              [3240, 8333],
              [3244, 8349],
              [3205, 8374],
              [3209, 8387],
              [3244, 8385],
              [3247, 8399],
              [3199, 8417],
              [3187, 8456],
              [3168, 8478],
              [3185, 8496],
              [3171, 8514],
              [3168, 8543],
              [3177, 8554],
              [3209, 8551],
              [3271, 8515],
              [3267, 8494],
              [3294, 8494],
              [3323, 8480],
              [3339, 8460],
              [3316, 8430],
              [3342, 8401],
              [3337, 8368],
              [3302, 8349]
            ]
          ],
          [
            [
              [2840, 8637],
              [2852, 8676],
              [2863, 8667],
              [2926, 8680],
              [2962, 8648],
              [2973, 8617],
              [2977, 8564],
              [2982, 8596],
              [3017, 8612],
              [3047, 8577],
              [3037, 8551],
              [3051, 8540],
              [3074, 8553],
              [3098, 8523],
              [3090, 8508],
              [3114, 8500],
              [3101, 8462],
              [3105, 8432],
              [3116, 8429],
              [3143, 8380],
              [3146, 8336],
              [3138, 8324],
              [3102, 8309],
              [3068, 8327],
              [3060, 8378],
              [3044, 8406],
              [2993, 8426],
              [2963, 8414],
              [2950, 8388],
              [2941, 8405],
              [2962, 8418],
              [2965, 8447],
              [2922, 8434],
              [2908, 8417],
              [2883, 8425],
              [2867, 8446],
              [2858, 8480],
              [2878, 8498],
              [2931, 8478],
              [2932, 8544],
              [2917, 8533],
              [2899, 8545],
              [2917, 8567],
              [2908, 8591],
              [2890, 8585],
              [2871, 8549],
              [2863, 8555],
              [2881, 8598],
              [2869, 8609],
              [2841, 8604],
              [2840, 8637]
            ]
          ],
          [
            [
              [3408, 8522],
              [3375, 8560],
              [3410, 8564],
              [3370, 8575],
              [3349, 8604],
              [3376, 8630],
              [3389, 8657],
              [3449, 8664],
              [3511, 8692],
              [3482, 8690],
              [3438, 8673],
              [3413, 8678],
              [3414, 8694],
              [3445, 8706],
              [3411, 8711],
              [3408, 8727],
              [3372, 8700],
              [3356, 8674],
              [3345, 8691],
              [3356, 8708],
              [3328, 8711],
              [3328, 8691],
              [3298, 8675],
              [3300, 8690],
              [3273, 8700],
              [3276, 8737],
              [3312, 8753],
              [3327, 8790],
              [3292, 8760],
              [3263, 8758],
              [3227, 8811],
              [3246, 8818],
              [3228, 8826],
              [3218, 8873],
              [3248, 8857],
              [3296, 8855],
              [3297, 8868],
              [3324, 8891],
              [3301, 8898],
              [3289, 8878],
              [3272, 8872],
              [3260, 8900],
              [3247, 8888],
              [3221, 8904],
              [3244, 8933],
              [3262, 8935],
              [3236, 8957],
              [3237, 8979],
              [3277, 8988],
              [3320, 8973],
              [3316, 8989],
              [3295, 8990],
              [3292, 9019],
              [3252, 9034],
              [3264, 9054],
              [3251, 9058],
              [3258, 9085],
              [3270, 9098],
              [3291, 9079],
              [3304, 9100],
              [3288, 9110],
              [3333, 9114],
              [3327, 9141],
              [3307, 9137],
              [3282, 9148],
              [3287, 9174],
              [3307, 9169],
              [3320, 9179],
              [3361, 9156],
              [3380, 9136],
              [3379, 9115],
              [3398, 9094],
              [3423, 9042],
              [3439, 9034],
              [3444, 9001],
              [3499, 9004],
              [3513, 8990],
              [3512, 8950],
              [3526, 8926],
              [3567, 8910],
              [3535, 8951],
              [3537, 8988],
              [3568, 8988],
              [3585, 8934],
              [3569, 8921],
              [3576, 8905],
              [3604, 8912],
              [3624, 8877],
              [3633, 8798],
              [3652, 8821],
              [3680, 8807],
              [3700, 8815],
              [3714, 8787],
              [3744, 8756],
              [3726, 8720],
              [3688, 8687],
              [3684, 8660],
              [3668, 8679],
              [3677, 8649],
              [3663, 8586],
              [3648, 8588],
              [3629, 8648],
              [3619, 8644],
              [3635, 8581],
              [3648, 8569],
              [3650, 8530],
              [3645, 8480],
              [3642, 8531],
              [3619, 8562],
              [3610, 8562],
              [3629, 8521],
              [3630, 8462],
              [3617, 8459],
              [3554, 8550],
              [3563, 8510],
              [3573, 8502],
              [3599, 8451],
              [3575, 8461],
              [3560, 8482],
              [3550, 8472],
              [3557, 8439],
              [3532, 8435],
              [3476, 8442],
              [3444, 8467],
              [3422, 8494],
              [3426, 8505],
              [3477, 8524],
              [3425, 8535],
              [3408, 8522]
            ]
          ],
          [
            [
              [4160, 8505],
              [4186, 8481],
              [4178, 8423],
              [4144, 8390],
              [4117, 8387],
              [4105, 8373],
              [4062, 8372],
              [4010, 8400],
              [4008, 8379],
              [4042, 8363],
              [4013, 8345],
              [4026, 8319],
              [4049, 8356],
              [4109, 8352],
              [4134, 8373],
              [4165, 8351],
              [4161, 8306],
              [4186, 8314],
              [4188, 8295],
              [4205, 8343],
              [4229, 8341],
              [4251, 8313],
              [4261, 8278],
              [4241, 8220],
              [4218, 8241],
              [4211, 8169],
              [4199, 8170],
              [4152, 8117],
              [4126, 8122],
              [4131, 8164],
              [4114, 8181],
              [4063, 8168],
              [4049, 8193],
              [4052, 8142],
              [4026, 8132],
              [3976, 8127],
              [3939, 8162],
              [3947, 8123],
              [3922, 8118],
              [3898, 8140],
              [3912, 8108],
              [3946, 8090],
              [3902, 8080],
              [3836, 8085],
              [3837, 8119],
              [3819, 8095],
              [3822, 8068],
              [3781, 8084],
              [3775, 8054],
              [3731, 8059],
              [3704, 8153],
              [3700, 8127],
              [3721, 8083],
              [3704, 8101],
              [3703, 8057],
              [3655, 8087],
              [3664, 8115],
              [3651, 8152],
              [3686, 8196],
              [3702, 8228],
              [3738, 8227],
              [3765, 8273],
              [3722, 8284],
              [3717, 8314],
              [3683, 8344],
              [3676, 8380],
              [3718, 8414],
              [3771, 8400],
              [3787, 8384],
              [3808, 8340],
              [3832, 8321],
              [3884, 8311],
              [3872, 8327],
              [3898, 8339],
              [3930, 8335],
              [3906, 8358],
              [3922, 8371],
              [3934, 8428],
              [3936, 8485],
              [3919, 8494],
              [3916, 8393],
              [3899, 8361],
              [3856, 8356],
              [3846, 8338],
              [3825, 8364],
              [3849, 8371],
              [3823, 8381],
              [3820, 8415],
              [3788, 8442],
              [3810, 8474],
              [3807, 8541],
              [3798, 8541],
              [3787, 8481],
              [3756, 8461],
              [3750, 8484],
              [3734, 8490],
              [3727, 8468],
              [3693, 8462],
              [3677, 8536],
              [3687, 8562],
              [3688, 8602],
              [3698, 8627],
              [3734, 8641],
              [3752, 8666],
              [3822, 8666],
              [3874, 8645],
              [3902, 8623],
              [3882, 8651],
              [3848, 8665],
              [3845, 8676],
              [3882, 8681],
              [3907, 8698],
              [3906, 8743],
              [3891, 8731],
              [3888, 8704],
              [3872, 8692],
              [3850, 8699],
              [3792, 8686],
              [3766, 8700],
              [3770, 8727],
              [3799, 8711],
              [3823, 8713],
              [3775, 8739],
              [3755, 8788],
              [3734, 8801],
              [3720, 8829],
              [3690, 8844],
              [3651, 8849],
              [3647, 8898],
              [3692, 8898],
              [3640, 8905],
              [3624, 8937],
              [3623, 8977],
              [3643, 8987],
              [3670, 8976],
              [3730, 8988],
              [3768, 8955],
              [3820, 8919],
              [3860, 8864],
              [3868, 8878],
              [3902, 8879],
              [3926, 8899],
              [3929, 8914],
              [3887, 8887],
              [3858, 8893],
              [3837, 8934],
              [3842, 8948],
              [3809, 8953],
              [3749, 9010],
              [3789, 9044],
              [3846, 9079],
              [3853, 9095],
              [3923, 9138],
              [3850, 9116],
              [3889, 9173],
              [3921, 9198],
              [3954, 9214],
              [3948, 9227],
              [3897, 9208],
              [3871, 9186],
              [3857, 9220],
              [3875, 9307],
              [3889, 9326],
              [3889, 9347],
              [3857, 9296],
              [3842, 9212],
              [3850, 9208],
              [3846, 9169],
              [3802, 9104],
              [3745, 9064],
              [3732, 9089],
              [3761, 9116],
              [3759, 9143],
              [3744, 9114],
              [3720, 9096],
              [3701, 9104],
              [3710, 9059],
              [3690, 9041],
              [3663, 9033],
              [3623, 9031],
              [3595, 9041],
              [3597, 9069],
              [3612, 9129],
              [3629, 9153],
              [3710, 9203],
              [3720, 9219],
              [3661, 9179],
              [3620, 9160],
              [3597, 9137],
              [3576, 9068],
              [3574, 9043],
              [3540, 9047],
              [3482, 9084],
              [3483, 9103],
              [3512, 9120],
              [3543, 9122],
              [3575, 9135],
              [3607, 9189],
              [3630, 9218],
              [3611, 9217],
              [3592, 9197],
              [3575, 9165],
              [3546, 9144],
              [3529, 9143],
              [3459, 9113],
              [3433, 9148],
              [3443, 9168],
              [3465, 9173],
              [3442, 9191],
              [3463, 9212],
              [3471, 9235],
              [3503, 9251],
              [3484, 9259],
              [3466, 9244],
              [3420, 9194],
              [3404, 9214],
              [3441, 9262],
              [3423, 9257],
              [3401, 9266],
              [3395, 9237],
              [3380, 9230],
              [3358, 9248],
              [3369, 9284],
              [3385, 9286],
              [3383, 9304],
              [3422, 9330],
              [3440, 9308],
              [3452, 9370],
              [3472, 9386],
              [3494, 9384],
              [3503, 9357],
              [3516, 9367],
              [3509, 9381],
              [3536, 9386],
              [3571, 9347],
              [3553, 9375],
              [3585, 9384],
              [3512, 9403],
              [3503, 9422],
              [3540, 9437],
              [3547, 9450],
              [3524, 9489],
              [3556, 9501],
              [3552, 9486],
              [3597, 9478],
              [3635, 9432],
              [3633, 9418],
              [3667, 9425],
              [3649, 9429],
              [3626, 9457],
              [3623, 9473],
              [3644, 9466],
              [3679, 9444],
              [3741, 9426],
              [3769, 9398],
              [3779, 9400],
              [3743, 9432],
              [3742, 9441],
              [3702, 9447],
              [3625, 9495],
              [3623, 9527],
              [3654, 9534],
              [3623, 9547],
              [3624, 9570],
              [3647, 9566],
              [3670, 9549],
              [3677, 9557],
              [3630, 9602],
              [3630, 9612],
              [3667, 9613],
              [3683, 9588],
              [3685, 9601],
              [3712, 9598],
              [3729, 9609],
              [3682, 9613],
              [3683, 9630],
              [3660, 9631],
              [3660, 9651],
              [3680, 9667],
              [3699, 9648],
              [3699, 9666],
              [3712, 9650],
              [3727, 9671],
              [3753, 9666],
              [3787, 9628],
              [3814, 9619],
              [3819, 9583],
              [3824, 9632],
              [3799, 9637],
              [3765, 9674],
              [3735, 9691],
              [3764, 9720],
              [3795, 9730],
              [3823, 9731],
              [3847, 9705],
              [3899, 9684],
              [3846, 9721],
              [3849, 9763],
              [3856, 9774],
              [3882, 9787],
              [3901, 9753],
              [3928, 9749],
              [3895, 9771],
              [3903, 9800],
              [3932, 9816],
              [3949, 9789],
              [3958, 9810],
              [3968, 9797],
              [3986, 9812],
              [3992, 9801],
              [4005, 9815],
              [4040, 9827],
              [4047, 9817],
              [4039, 9777],
              [4017, 9740],
              [4019, 9726],
              [4048, 9750],
              [4067, 9815],
              [4087, 9807],
              [4079, 9838],
              [4089, 9847],
              [4098, 9830],
              [4115, 9820],
              [4113, 9842],
              [4132, 9851],
              [4142, 9825],
              [4177, 9811],
              [4190, 9798],
              [4228, 9815],
              [4255, 9802],
              [4276, 9761],
              [4265, 9736],
              [4275, 9708],
              [4254, 9607],
              [4219, 9596],
              [4208, 9570],
              [4230, 9579],
              [4222, 9559],
              [4199, 9544],
              [4157, 9504],
              [4152, 9487],
              [4186, 9522],
              [4214, 9518],
              [4185, 9467],
              [4180, 9446],
              [4144, 9386],
              [4161, 9401],
              [4243, 9534],
              [4272, 9568],
              [4288, 9533],
              [4281, 9494],
              [4268, 9474],
              [4270, 9422],
              [4250, 9333],
              [4247, 9270],
              [4254, 9236],
              [4248, 9222],
              [4225, 9210],
              [4211, 9235],
              [4186, 9242],
              [4217, 9221],
              [4222, 9205],
              [4248, 9196],
              [4247, 9176],
              [4226, 9170],
              [4190, 9112],
              [4212, 9126],
              [4237, 9158],
              [4251, 9125],
              [4231, 9102],
              [4254, 9100],
              [4249, 9057],
              [4228, 9027],
              [4197, 9024],
              [4181, 9043],
              [4128, 9041],
              [4109, 9021],
              [4166, 9023],
              [4173, 9030],
              [4204, 8983],
              [4179, 8948],
              [4153, 8937],
              [4134, 8940],
              [4147, 8914],
              [4125, 8911],
              [4089, 8921],
              [4114, 8893],
              [4075, 8880],
              [4054, 8900],
              [4044, 8893],
              [4062, 8867],
              [4037, 8865],
              [4063, 8853],
              [4110, 8874],
              [4122, 8869],
              [4183, 8892],
              [4174, 8879],
              [4200, 8851],
              [4176, 8839],
              [4136, 8841],
              [4119, 8859],
              [4040, 8822],
              [4125, 8841],
              [4075, 8796],
              [4057, 8797],
              [4062, 8733],
              [4072, 8781],
              [4108, 8812],
              [4152, 8816],
              [4155, 8803],
              [4134, 8781],
              [4181, 8803],
              [4208, 8802],
              [4220, 8782],
              [4229, 8748],
              [4211, 8722],
              [4160, 8709],
              [4186, 8699],
              [4236, 8697],
              [4229, 8649],
              [4181, 8644],
              [4172, 8628],
              [4210, 8625],
              [4239, 8632],
              [4237, 8592],
              [4218, 8600],
              [4199, 8563],
              [4183, 8567],
              [4135, 8553],
              [4128, 8537],
              [4156, 8524],
              [4174, 8531],
              [4160, 8505]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.NT',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.42,
        'hc-middle-y': 0.76,
        'hc-key': 'ca-nt',
        'hc-a2': 'NT',
        labelrank: '2',
        hasc: 'CA.NT',
        'alt-name': 'Territoires du Nord-Ouest',
        'woe-id': '2344920',
        subregion: null,
        fips: 'CA13',
        'postal-code': 'NT',
        name: 'Northwest Territories',
        country: 'Canada',
        'type-en': 'Territory',
        region: 'Northern Canada',
        longitude: '-119.942',
        'woe-name': 'Northwest Territories',
        latitude: '64.0831',
        'woe-label': 'Northwest Territories, CA, Canada',
        type: 'Territoire'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [2387, 8156],
              [2397, 8128],
              [2382, 8115],
              [2322, 8141],
              [2351, 8163],
              [2387, 8156]
            ]
          ],
          [
            [
              [1038, 4617],
              [639, 4744],
              [607, 4913],
              [629, 4930],
              [630, 4971],
              [544, 4961],
              [495, 5005],
              [476, 4991],
              [388, 5020],
              [405, 5077],
              [418, 5169],
              [384, 5194],
              [357, 5247],
              [340, 5358],
              [314, 5354],
              [285, 5381],
              [286, 5429],
              [313, 5455],
              [295, 5494],
              [292, 5554],
              [326, 5592],
              [306, 5605],
              [301, 5662],
              [343, 5681],
              [337, 5739],
              [347, 5753],
              [308, 5817],
              [316, 5923],
              [299, 5942],
              [254, 5942],
              [279, 5965],
              [265, 6015],
              [229, 6052],
              [274, 6092],
              [255, 6133],
              [272, 6153],
              [341, 6194],
              [335, 6261],
              [363, 6271],
              [354, 6297],
              [309, 6294],
              [325, 6311],
              [277, 6316],
              [268, 6353],
              [300, 6391],
              [283, 6404],
              [326, 6443],
              [325, 6485],
              [338, 6497],
              [337, 6544],
              [354, 6539],
              [178, 6637],
              [193, 6675],
              [223, 6706],
              [238, 6745],
              [237, 6786],
              [369, 7013],
              [392, 6993],
              [417, 6925],
              [430, 6946],
              [427, 6980],
              [409, 6989],
              [419, 7030],
              [455, 7066],
              [501, 7055],
              [508, 7069],
              [546, 7064],
              [562, 7040],
              [603, 7089],
              [597, 7046],
              [621, 7055],
              [615, 7024],
              [556, 6992],
              [616, 7000],
              [645, 6986],
              [694, 7025],
              [716, 7007],
              [726, 7029],
              [777, 7010],
              [826, 7034],
              [828, 7000],
              [860, 7036],
              [895, 7046],
              [942, 7010],
              [974, 7041],
              [979, 7005],
              [953, 6982],
              [870, 6970],
              [820, 6939],
              [820, 6959],
              [744, 6969],
              [718, 6939],
              [694, 6938],
              [671, 6912],
              [675, 6942],
              [628, 6910],
              [609, 6913],
              [576, 6882],
              [618, 6847],
              [634, 6905],
              [727, 6915],
              [761, 6945],
              [787, 6938],
              [789, 6907],
              [816, 6933],
              [790, 6879],
              [875, 6947],
              [974, 6940],
              [968, 6900],
              [1043, 6942],
              [1048, 6966],
              [1074, 6977],
              [1115, 6972],
              [1089, 6996],
              [1086, 7018],
              [1104, 7048],
              [1104, 7075],
              [1139, 7002],
              [1148, 6962],
              [1138, 6849],
              [1165, 6755],
              [1195, 6721],
              [1219, 6727],
              [1206, 6763],
              [1230, 6748],
              [1217, 6780],
              [1228, 6797],
              [1256, 6799],
              [1281, 6836],
              [1279, 6855],
              [1332, 6868],
              [1309, 6833],
              [1310, 6806],
              [1294, 6779],
              [1324, 6770],
              [1271, 6705],
              [1306, 6700],
              [1327, 6683],
              [1373, 6699],
              [1394, 6756],
              [1414, 6765],
              [1479, 6739],
              [1521, 6714],
              [1562, 6653],
              [1465, 6325],
              [1467, 6320],
              [2035, 5627],
              [2197, 5603],
              [2284, 5466],
              [2315, 5435],
              [2382, 5413],
              [2964, 5273],
              [2988, 5267],
              [2984, 4342],
              [2984, 4342],
              [2110, 4398],
              [1038, 4617]
            ]
          ],
          [
            [
              [2080, 7998],
              [2105, 8002],
              [2144, 8030],
              [2152, 8019],
              [2107, 7947],
              [2056, 7905],
              [2018, 7938],
              [2080, 7998]
            ]
          ],
          [
            [
              [2409, 8435],
              [2407, 8419],
              [2429, 8388],
              [2432, 8366],
              [2400, 8348],
              [2374, 8389],
              [2366, 8415],
              [2409, 8435]
            ]
          ],
          [
            [
              [2455, 7135],
              [2440, 7151],
              [2456, 7141],
              [2455, 7135]
            ]
          ],
          [
            [
              [2461, 7182],
              [2459, 7164],
              [2453, 7173],
              [2461, 7182]
            ]
          ],
          [
            [
              [2462, 7192],
              [2433, 7215],
              [2424, 7255],
              [2469, 7244],
              [2462, 7192]
            ]
          ],
          [
            [
              [2551, 7896],
              [2549, 7901],
              [2552, 7904],
              [2551, 7896]
            ]
          ],
          [
            [
              [2561, 7976],
              [2543, 7995],
              [2547, 8025],
              [2569, 8035],
              [2561, 7976]
            ]
          ],
          [
            [
              [2542, 7820],
              [2522, 7664],
              [2480, 7651],
              [2483, 7639],
              [2412, 7598],
              [2362, 7586],
              [2326, 7588],
              [2288, 7606],
              [2254, 7668],
              [2269, 7682],
              [2316, 7692],
              [2362, 7718],
              [2436, 7712],
              [2479, 7761],
              [2452, 7750],
              [2394, 7744],
              [2400, 7762],
              [2353, 7745],
              [2299, 7750],
              [2320, 7807],
              [2346, 7821],
              [2306, 7816],
              [2270, 7754],
              [2236, 7738],
              [2224, 7748],
              [2230, 7786],
              [2192, 7747],
              [2166, 7775],
              [2173, 7808],
              [2145, 7794],
              [2101, 7822],
              [2107, 7857],
              [2134, 7880],
              [2199, 7866],
              [2229, 7883],
              [2248, 7883],
              [2265, 7905],
              [2199, 7888],
              [2139, 7901],
              [2167, 7944],
              [2282, 7938],
              [2284, 7947],
              [2209, 7954],
              [2183, 7967],
              [2199, 7980],
              [2191, 8002],
              [2206, 8023],
              [2228, 8028],
              [2290, 8009],
              [2277, 8026],
              [2250, 8031],
              [2248, 8058],
              [2275, 8078],
              [2333, 8076],
              [2344, 8067],
              [2345, 8001],
              [2401, 8010],
              [2427, 7982],
              [2426, 7950],
              [2456, 7926],
              [2429, 7907],
              [2469, 7899],
              [2464, 7847],
              [2470, 7825],
              [2514, 7831],
              [2542, 7820]
            ]
          ],
          [
            [
              [2616, 8406],
              [2611, 8367],
              [2568, 8359],
              [2571, 8334],
              [2600, 8333],
              [2600, 8301],
              [2587, 8270],
              [2552, 8253],
              [2532, 8261],
              [2487, 8243],
              [2470, 8256],
              [2466, 8279],
              [2440, 8298],
              [2453, 8385],
              [2504, 8402],
              [2582, 8412],
              [2616, 8406]
            ]
          ],
          [
            [
              [2633, 8543],
              [2632, 8539],
              [2622, 8460],
              [2606, 8452],
              [2583, 8462],
              [2570, 8481],
              [2553, 8456],
              [2537, 8458],
              [2522, 8485],
              [2477, 8468],
              [2467, 8485],
              [2475, 8500],
              [2530, 8527],
              [2545, 8522],
              [2580, 8553],
              [2616, 8564],
              [2633, 8543]
            ]
          ],
          [
            [
              [2454, 7126],
              [2386, 6581],
              [2197, 6608],
              [2195, 6575],
              [2163, 6576],
              [2167, 6613],
              [1852, 6678],
              [1845, 6654],
              [1870, 6589],
              [1854, 6597],
              [1830, 6629],
              [1828, 6681],
              [1870, 6703],
              [1944, 6707],
              [2084, 6700],
              [2135, 6683],
              [2198, 6653],
              [2234, 6665],
              [2224, 6686],
              [2270, 6667],
              [2241, 6712],
              [2190, 6732],
              [2150, 6770],
              [2115, 6785],
              [2099, 6777],
              [1900, 6779],
              [1915, 6802],
              [1876, 6814],
              [1869, 6799],
              [1820, 6878],
              [1816, 6921],
              [1865, 6943],
              [1889, 6941],
              [1994, 6960],
              [1989, 6972],
              [2026, 6984],
              [2046, 6966],
              [2047, 6986],
              [2022, 6993],
              [1893, 6983],
              [1851, 6995],
              [1846, 7017],
              [1862, 7029],
              [1897, 7028],
              [1873, 7055],
              [1844, 7043],
              [1844, 7061],
              [1804, 7064],
              [1807, 7098],
              [1822, 7131],
              [1859, 7169],
              [1900, 7178],
              [1905, 7196],
              [1881, 7230],
              [1919, 7268],
              [1944, 7277],
              [1987, 7317],
              [2021, 7320],
              [2073, 7343],
              [2117, 7353],
              [2188, 7380],
              [2206, 7366],
              [2217, 7315],
              [2199, 7243],
              [2153, 7209],
              [2168, 7196],
              [2186, 7209],
              [2211, 7199],
              [2236, 7221],
              [2225, 7230],
              [2245, 7261],
              [2274, 7280],
              [2330, 7244],
              [2381, 7196],
              [2371, 7162],
              [2327, 7126],
              [2337, 7105],
              [2361, 7127],
              [2380, 7097],
              [2380, 7125],
              [2409, 7158],
              [2432, 7152],
              [2454, 7126]
            ]
          ],
          [
            [
              [1858, 7705],
              [1894, 7660],
              [1950, 7628],
              [1948, 7581],
              [1976, 7624],
              [2018, 7627],
              [2055, 7606],
              [2080, 7566],
              [2120, 7474],
              [2135, 7459],
              [2146, 7411],
              [2113, 7390],
              [2063, 7378],
              [2005, 7347],
              [1855, 7284],
              [1827, 7225],
              [1792, 7208],
              [1760, 7220],
              [1761, 7196],
              [1731, 7163],
              [1718, 7106],
              [1688, 7066],
              [1627, 7058],
              [1614, 7083],
              [1569, 7048],
              [1492, 7032],
              [1481, 7075],
              [1483, 7124],
              [1472, 7185],
              [1440, 7221],
              [1413, 7267],
              [1371, 7285],
              [1390, 7313],
              [1452, 7380],
              [1480, 7389],
              [1497, 7458],
              [1537, 7454],
              [1526, 7497],
              [1543, 7506],
              [1577, 7558],
              [1609, 7575],
              [1619, 7601],
              [1644, 7617],
              [1628, 7643],
              [1626, 7698],
              [1636, 7752],
              [1630, 7762],
              [1722, 7754],
              [1762, 7744],
              [1829, 7745],
              [1852, 7727],
              [1858, 7705]
            ]
          ],
          [
            [
              [2284, 8338],
              [2321, 8279],
              [2322, 8269],
              [2263, 8239],
              [2267, 8218],
              [2287, 8195],
              [2270, 8183],
              [2267, 8137],
              [2238, 8115],
              [2196, 8112],
              [2195, 8072],
              [2167, 8056],
              [2141, 8096],
              [2161, 8160],
              [2176, 8177],
              [2144, 8183],
              [2133, 8173],
              [2135, 8137],
              [2095, 8129],
              [2108, 8091],
              [2089, 8081],
              [2080, 8057],
              [2058, 8049],
              [2060, 8106],
              [2043, 8090],
              [2040, 8036],
              [2009, 8002],
              [1996, 8015],
              [1975, 8009],
              [1988, 8035],
              [1975, 8047],
              [1985, 8077],
              [1977, 8092],
              [1960, 8065],
              [1955, 8036],
              [1936, 8036],
              [1916, 8074],
              [1901, 8078],
              [1877, 8060],
              [1870, 8076],
              [1886, 8098],
              [1882, 8117],
              [1861, 8108],
              [1878, 8133],
              [1913, 8163],
              [1958, 8156],
              [1998, 8200],
              [2044, 8221],
              [2070, 8259],
              [2117, 8291],
              [2127, 8311],
              [2155, 8321],
              [2204, 8316],
              [2229, 8285],
              [2263, 8301],
              [2242, 8323],
              [2284, 8338]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.AB',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.46,
        'hc-middle-y': 0.5,
        'hc-key': 'ca-ab',
        'hc-a2': 'AB',
        labelrank: '2',
        hasc: 'CA.AB',
        'alt-name': null,
        'woe-id': '2344915',
        subregion: 'Prairies',
        fips: 'CA01',
        'postal-code': 'AB',
        name: 'Alberta',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Western Canada',
        longitude: '-115',
        'woe-name': 'Alberta',
        latitude: '55.2816',
        'woe-label': 'Alberta, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1038, 4617],
            [2110, 4398],
            [1807, 1997],
            [1807, 1996],
            [1439, 2049],
            [1220, 2088],
            [1205, 2135],
            [1184, 2143],
            [1148, 2235],
            [1173, 2275],
            [1177, 2404],
            [1155, 2456],
            [1128, 2458],
            [1115, 2502],
            [1079, 2537],
            [1088, 2562],
            [1042, 2611],
            [985, 2775],
            [947, 2764],
            [920, 2872],
            [881, 2873],
            [859, 2912],
            [874, 2937],
            [845, 2962],
            [812, 2944],
            [817, 3013],
            [789, 3066],
            [783, 3123],
            [759, 3156],
            [749, 3135],
            [723, 3157],
            [717, 3194],
            [673, 3220],
            [664, 3269],
            [685, 3260],
            [669, 3324],
            [1038, 4617]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.NL',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.31,
        'hc-middle-y': 0.61,
        'hc-key': 'ca-nl',
        'hc-a2': 'NL',
        labelrank: '2',
        hasc: 'CA.NF',
        'alt-name': 'Newfoundland|Terre-Neuve|Terre-Neuve-et-Labrador',
        'woe-id': '2344919',
        subregion: 'Atlantic Canada',
        fips: 'CA05',
        'postal-code': 'NL',
        name: 'Newfoundland and Labrador',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Eastern Canada',
        longitude: '-56.2169',
        'woe-name': 'Newfoundland and Labrador',
        latitude: '48.6598',
        'woe-label': 'Newfoundland and Labrador, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8200, 4847],
              [8202, 4804],
              [8177, 4783],
              [8143, 4695],
              [8100, 4667],
              [8087, 4637],
              [8112, 4591],
              [8050, 4595],
              [8007, 4583],
              [8120, 4589],
              [8111, 4538],
              [8128, 4533],
              [8146, 4604],
              [8205, 4711],
              [8189, 4721],
              [8192, 4764],
              [8245, 4849],
              [8210, 4833],
              [8217, 4865],
              [8299, 4919],
              [8396, 4868],
              [8372, 4816],
              [8398, 4825],
              [8413, 4795],
              [8421, 4834],
              [8401, 4854],
              [8455, 4929],
              [8457, 4900],
              [8549, 4916],
              [8570, 4936],
              [8593, 4889],
              [8619, 4882],
              [8608, 4832],
              [8642, 4837],
              [8691, 4797],
              [8656, 4739],
              [8699, 4770],
              [8729, 4772],
              [8727, 4738],
              [8772, 4713],
              [8773, 4659],
              [8734, 4549],
              [8740, 4507],
              [8720, 4471],
              [8639, 4571],
              [7908, 4040],
              [7863, 4100],
              [7812, 4103],
              [7814, 4132],
              [7866, 4191],
              [7828, 4195],
              [7780, 4146],
              [7788, 4113],
              [7817, 4083],
              [7853, 4000],
              [7838, 3998],
              [7877, 3952],
              [7865, 3906],
              [7817, 3920],
              [7768, 3892],
              [7694, 3930],
              [7641, 3888],
              [7579, 3910],
              [7587, 3877],
              [7553, 3906],
              [7565, 3920],
              [7533, 3960],
              [7544, 3972],
              [7480, 4043],
              [7469, 4011],
              [7476, 3993],
              [7481, 3982],
              [7472, 3942],
              [7398, 3952],
              [7363, 3992],
              [7410, 4013],
              [7385, 4084],
              [7319, 4084],
              [7271, 4119],
              [7213, 4142],
              [7215, 4182],
              [7177, 4221],
              [7197, 4248],
              [7187, 4269],
              [7224, 4262],
              [7217, 4321],
              [7143, 4362],
              [7258, 4347],
              [7205, 4438],
              [7213, 4452],
              [7278, 4425],
              [7334, 4432],
              [7370, 4410],
              [7395, 4431],
              [7407, 4493],
              [7460, 4490],
              [7495, 4506],
              [7551, 4500],
              [7591, 4529],
              [7556, 4542],
              [7546, 4577],
              [7573, 4585],
              [7540, 4648],
              [7523, 4653],
              [7540, 4697],
              [7495, 4674],
              [7462, 4735],
              [7427, 4755],
              [7456, 4799],
              [7391, 4772],
              [7376, 4810],
              [7350, 4807],
              [7334, 4831],
              [7360, 4851],
              [7306, 4879],
              [7308, 4932],
              [7280, 5002],
              [7233, 5085],
              [7185, 5082],
              [7103, 5138],
              [7123, 5229],
              [7097, 5223],
              [7079, 5252],
              [7121, 5290],
              [7085, 5306],
              [7061, 5258],
              [7028, 5271],
              [6968, 5246],
              [6961, 5269],
              [7007, 5283],
              [6959, 5332],
              [6943, 5384],
              [6928, 5354],
              [6893, 5362],
              [6871, 5414],
              [6871, 5445],
              [6836, 5451],
              [6856, 5482],
              [6817, 5495],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6870, 5504],
              [6872, 5484],
              [6914, 5484],
              [6949, 5428],
              [6984, 5432],
              [7013, 5402],
              [6991, 5380],
              [7047, 5404],
              [7082, 5385],
              [7066, 5331],
              [7090, 5368],
              [7167, 5346],
              [7193, 5323],
              [7178, 5260],
              [7207, 5269],
              [7239, 5310],
              [7271, 5246],
              [7233, 5215],
              [7247, 5183],
              [7251, 5221],
              [7292, 5258],
              [7347, 5227],
              [7375, 5246],
              [7415, 5242],
              [7416, 5222],
              [7372, 5223],
              [7408, 5188],
              [7452, 5193],
              [7438, 5158],
              [7446, 5121],
              [7482, 5119],
              [7526, 5141],
              [7537, 5065],
              [7515, 5049],
              [7539, 5020],
              [7450, 5001],
              [7534, 5012],
              [7627, 5033],
              [7544, 4990],
              [7543, 4968],
              [7615, 5005],
              [7607, 4973],
              [7560, 4945],
              [7584, 4940],
              [7643, 4982],
              [7672, 4958],
              [7674, 4991],
              [7704, 4968],
              [7718, 4935],
              [7803, 4972],
              [7800, 4943],
              [7860, 4922],
              [7865, 4814],
              [7884, 4902],
              [7901, 4889],
              [7914, 4937],
              [7941, 4897],
              [7974, 4930],
              [7967, 4851],
              [7983, 4915],
              [7982, 4956],
              [8012, 4964],
              [8064, 4919],
              [8187, 4982],
              [8219, 4978],
              [8239, 4998],
              [8277, 4987],
              [8253, 4933],
              [8204, 4889],
              [8213, 4869],
              [8200, 4847]
            ],
            [
              [8200, 4847],
              [8199, 4852],
              [8195, 4838],
              [8195, 4838],
              [8195, 4838],
              [8195, 4838],
              [8178, 4810],
              [8121, 4740],
              [8135, 4742],
              [8184, 4808],
              [8195, 4838],
              [8195, 4838],
              [8195, 4838],
              [8195, 4838],
              [8200, 4847]
            ]
          ],
          [
            [
              [7544, 5104],
              [7556, 5073],
              [7588, 5051],
              [7548, 5053],
              [7544, 5104]
            ]
          ],
          [
            [
              [9596, 4050],
              [9596, 4048],
              [9593, 4049],
              [9593, 4049],
              [9596, 4050],
              [9596, 4050],
              [9596, 4050]
            ]
          ],
          [
            [
              [9596, 4050],
              [9585, 4112],
              [9611, 4057],
              [9596, 4050],
              [9596, 4050],
              [9596, 4050]
            ]
          ],
          [
            [
              [6842, 5539],
              [6842, 5529],
              [6840, 5524],
              [6838, 5533],
              [6842, 5539]
            ]
          ],
          [
            [
              [6841, 5520],
              [6861, 5518],
              [6833, 5512],
              [6833, 5512],
              [6841, 5520]
            ]
          ],
          [
            [
              [6833, 5512],
              [6832, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512]
            ]
          ],
          [
            [
              [9495, 3972],
              [9518, 4014],
              [9512, 4048],
              [9484, 3998],
              [9436, 4001],
              [9464, 3949],
              [9411, 3900],
              [9412, 3939],
              [9356, 3908],
              [9291, 3823],
              [9216, 3790],
              [9171, 3751],
              [9127, 3740],
              [9018, 3617],
              [8988, 3609],
              [8941, 3648],
              [8960, 3801],
              [8975, 3847],
              [8932, 3830],
              [8878, 3766],
              [8891, 3825],
              [8928, 3840],
              [8913, 3864],
              [8889, 3960],
              [8948, 3962],
              [8920, 3984],
              [8936, 4012],
              [8890, 3998],
              [8872, 4033],
              [8896, 4076],
              [8864, 4101],
              [8837, 4210],
              [8791, 4352],
              [8808, 4401],
              [8775, 4487],
              [8827, 4618],
              [8838, 4591],
              [8877, 4647],
              [8894, 4582],
              [8839, 4559],
              [8864, 4532],
              [8901, 4553],
              [8914, 4532],
              [8954, 4264],
              [9008, 4174],
              [8999, 4252],
              [9013, 4276],
              [9000, 4339],
              [9028, 4306],
              [9046, 4342],
              [9073, 4337],
              [9092, 4376],
              [9106, 4359],
              [9074, 4269],
              [9101, 4289],
              [9105, 4217],
              [9122, 4257],
              [9165, 4256],
              [9164, 4285],
              [9210, 4294],
              [9232, 4260],
              [9273, 4314],
              [9273, 4395],
              [9300, 4381],
              [9328, 4423],
              [9426, 4440],
              [9439, 4392],
              [9417, 4354],
              [9477, 4284],
              [9528, 4307],
              [9523, 4342],
              [9556, 4343],
              [9548, 4387],
              [9573, 4381],
              [9588, 4320],
              [9565, 4307],
              [9566, 4266],
              [9611, 4146],
              [9669, 4148],
              [9645, 4188],
              [9629, 4255],
              [9658, 4306],
              [9690, 4193],
              [9725, 4168],
              [9736, 4230],
              [9716, 4266],
              [9777, 4241],
              [9792, 4180],
              [9851, 4087],
              [9844, 4033],
              [9822, 4045],
              [9807, 3995],
              [9769, 4016],
              [9724, 4083],
              [9722, 3976],
              [9693, 3974],
              [9653, 4089],
              [9578, 4147],
              [9549, 4142],
              [9575, 4053],
              [9593, 4049],
              [9593, 4049],
              [9580, 4044],
              [9558, 3998],
              [9541, 3999],
              [9547, 3932],
              [9566, 3873],
              [9518, 3814],
              [9486, 3802],
              [9471, 3839],
              [9507, 3888],
              [9495, 3972]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.SK',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.55,
        'hc-middle-y': 0.51,
        'hc-key': 'ca-sk',
        'hc-a2': 'SK',
        labelrank: '2',
        hasc: 'CA.SK',
        'alt-name': null,
        'woe-id': '2344925',
        subregion: 'Prairies',
        fips: 'CA11',
        'postal-code': 'SK',
        name: 'Saskatchewan',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Western Canada',
        longitude: '-105.682',
        'woe-name': 'Saskatchewan',
        latitude: '54.4965',
        'woe-label': 'Saskatchewan, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2110, 4398],
            [2984, 4342],
            [2981, 3426],
            [3068, 1920],
            [2912, 1920],
            [1807, 1996],
            [1807, 1997],
            [2110, 4398]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.MB',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.37,
        'hc-middle-y': 0.43,
        'hc-key': 'ca-mb',
        'hc-a2': 'MB',
        labelrank: '2',
        hasc: 'CA.MB',
        'alt-name': null,
        'woe-id': '2344917',
        subregion: 'Prairies',
        fips: 'CA03',
        'postal-code': 'MB',
        name: 'Manitoba',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Western Canada',
        longitude: '-97.3828',
        'woe-name': 'Manitoba',
        latitude: '54.85',
        'woe-label': 'Manitoba, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2984, 4342],
            [3772, 4382],
            [3772, 4382],
            [3772, 4382],
            [3778, 4305],
            [3796, 4240],
            [3794, 4168],
            [3843, 4109],
            [3867, 4130],
            [3987, 4131],
            [3996, 4084],
            [4046, 3991],
            [4058, 3946],
            [4112, 3841],
            [4091, 3749],
            [4114, 3771],
            [4146, 3772],
            [4278, 3846],
            [4332, 3848],
            [4430, 3809],
            [4539, 3802],
            [4442, 3641],
            [4305, 3418],
            [4179, 3213],
            [4056, 3018],
            [3891, 2811],
            [3966, 2051],
            [3972, 1968],
            [3068, 1920],
            [2981, 3426],
            [2984, 4317],
            [2984, 4342]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.QC',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.38,
        'hc-middle-y': 0.41,
        'hc-key': 'ca-qc',
        'hc-a2': 'QC',
        labelrank: '2',
        hasc: 'CA.QC',
        'alt-name': 'Lower Canada',
        'woe-id': '2344924',
        subregion: 'Québec',
        fips: 'CA10',
        'postal-code': 'QC',
        name: 'Québec',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Eastern Canada',
        longitude: '-73.71680000000001',
        'woe-name': 'Québec',
        latitude: '52.2593',
        'woe-label': 'Quebec, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7476, 3993],
              [7480, 4043],
              [7544, 3972],
              [7533, 3960],
              [7565, 3920],
              [7553, 3906],
              [7587, 3877],
              [7579, 3910],
              [7641, 3888],
              [7694, 3930],
              [7768, 3892],
              [7817, 3920],
              [7865, 3906],
              [7877, 3952],
              [7817, 4083],
              [7780, 4146],
              [7828, 4195],
              [7866, 4191],
              [7814, 4132],
              [7812, 4103],
              [7863, 4100],
              [7908, 4040],
              [8639, 4571],
              [8720, 4471],
              [8691, 4474],
              [8648, 4432],
              [8637, 4380],
              [8605, 4355],
              [8572, 4240],
              [8597, 4210],
              [8572, 4144],
              [8565, 4047],
              [8545, 4000],
              [8459, 3950],
              [8376, 3849],
              [8343, 3861],
              [8181, 3767],
              [8158, 3734],
              [8103, 3723],
              [8056, 3680],
              [8023, 3673],
              [7979, 3632],
              [7928, 3614],
              [7843, 3528],
              [7795, 3518],
              [7777, 3486],
              [7755, 3383],
              [7782, 3303],
              [7779, 3271],
              [7698, 3213],
              [7678, 3176],
              [7701, 3171],
              [7655, 3128],
              [7626, 3037],
              [7626, 2920],
              [7594, 2868],
              [7557, 2879],
              [7405, 2848],
              [7449, 2842],
              [7484, 2861],
              [7554, 2871],
              [7606, 2866],
              [7616, 2783],
              [7604, 2707],
              [7576, 2679],
              [7578, 2598],
              [7555, 2562],
              [7529, 2478],
              [7461, 2433],
              [7426, 2382],
              [7398, 2306],
              [7351, 2261],
              [7345, 2221],
              [7392, 2272],
              [7407, 2325],
              [7468, 2431],
              [7489, 2432],
              [7535, 2483],
              [7564, 2568],
              [7561, 2525],
              [7613, 2589],
              [7634, 2716],
              [7684, 2935],
              [7750, 3076],
              [7898, 3284],
              [7939, 3331],
              [8014, 3391],
              [8094, 3428],
              [8159, 3437],
              [8224, 3425],
              [8246, 3405],
              [8187, 3399],
              [8263, 3380],
              [8265, 3324],
              [8228, 3280],
              [8237, 3251],
              [8178, 3162],
              [8120, 3156],
              [8093, 3168],
              [8082, 3128],
              [8027, 3098],
              [7997, 3052],
              [7938, 2986],
              [7897, 2994],
              [7832, 2957],
              [7805, 2924],
              [7844, 2851],
              [7835, 2815],
              [7783, 2750],
              [7770, 2775],
              [7740, 2764],
              [7717, 2566],
              [7737, 2504],
              [7741, 2418],
              [7759, 2399],
              [7762, 2343],
              [7739, 2291],
              [7742, 2210],
              [7716, 2222],
              [7677, 2188],
              [7680, 2121],
              [7216, 1901],
              [7245, 1931],
              [7326, 2057],
              [7346, 2062],
              [7335, 2140],
              [7344, 2209],
              [7331, 2127],
              [7334, 2063],
              [7276, 2039],
              [7293, 2023],
              [7249, 1970],
              [7221, 1982],
              [7211, 2040],
              [7167, 2041],
              [7081, 1985],
              [7009, 1912],
              [6975, 1926],
              [6935, 1899],
              [6882, 1904],
              [6835, 1956],
              [6818, 1928],
              [6684, 1972],
              [6521, 1947],
              [6467, 1975],
              [6358, 2067],
              [6309, 2137],
              [6310, 2164],
              [6061, 2872],
              [6096, 2849],
              [6059, 2877],
              [6030, 2960],
              [6022, 2981],
              [6031, 3030],
              [6051, 3006],
              [6090, 3003],
              [6118, 2961],
              [6106, 3045],
              [6062, 3066],
              [6068, 3110],
              [6094, 3157],
              [6087, 3213],
              [6062, 3248],
              [6028, 3263],
              [6017, 3298],
              [5975, 3330],
              [5954, 3405],
              [5923, 3424],
              [5902, 3536],
              [5882, 3566],
              [5840, 3554],
              [5807, 3605],
              [5760, 3633],
              [5896, 3770],
              [5949, 3847],
              [5995, 3959],
              [5987, 3964],
              [6015, 4061],
              [6010, 4111],
              [5974, 4213],
              [5925, 4308],
              [5868, 4381],
              [5816, 4427],
              [5735, 4468],
              [5679, 4475],
              [5599, 4512],
              [5585, 4560],
              [5604, 4586],
              [5608, 4640],
              [5632, 4668],
              [5610, 4705],
              [5604, 4749],
              [5647, 4793],
              [5625, 4811],
              [5636, 4837],
              [5590, 4834],
              [5608, 4857],
              [5551, 4903],
              [5562, 4935],
              [5526, 4944],
              [5539, 4976],
              [5511, 4964],
              [5475, 4977],
              [5493, 5036],
              [5467, 5112],
              [5488, 5127],
              [5447, 5162],
              [5433, 5155],
              [5404, 5189],
              [5366, 5271],
              [5406, 5354],
              [5459, 5364],
              [5611, 5361],
              [5632, 5382],
              [5698, 5372],
              [5696, 5394],
              [5723, 5406],
              [5772, 5482],
              [5830, 5468],
              [5855, 5450],
              [5901, 5455],
              [5920, 5421],
              [5961, 5426],
              [6002, 5396],
              [6037, 5406],
              [6035, 5354],
              [6112, 5321],
              [6210, 5342],
              [6240, 5364],
              [6278, 5330],
              [6291, 5397],
              [6335, 5350],
              [6315, 5311],
              [6321, 5275],
              [6347, 5239],
              [6373, 5228],
              [6379, 5177],
              [6326, 5154],
              [6304, 5131],
              [6383, 5171],
              [6414, 5161],
              [6432, 5095],
              [6465, 5049],
              [6477, 5070],
              [6511, 5058],
              [6492, 5019],
              [6533, 5045],
              [6542, 5026],
              [6501, 5011],
              [6525, 4979],
              [6489, 4932],
              [6521, 4904],
              [6523, 4945],
              [6544, 4991],
              [6588, 5020],
              [6645, 5017],
              [6687, 4981],
              [6715, 4896],
              [6712, 4869],
              [6670, 4825],
              [6655, 4792],
              [6715, 4865],
              [6721, 4893],
              [6695, 4980],
              [6765, 4991],
              [6780, 4932],
              [6816, 5043],
              [6839, 5067],
              [6832, 5142],
              [6903, 5123],
              [6867, 5144],
              [6879, 5227],
              [6847, 5257],
              [6881, 5281],
              [6839, 5310],
              [6847, 5325],
              [6813, 5355],
              [6830, 5394],
              [6829, 5429],
              [6804, 5513],
              [6841, 5520],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6833, 5512],
              [6817, 5495],
              [6856, 5482],
              [6836, 5451],
              [6871, 5445],
              [6871, 5414],
              [6893, 5362],
              [6928, 5354],
              [6943, 5384],
              [6959, 5332],
              [7007, 5283],
              [6961, 5269],
              [6968, 5246],
              [7028, 5271],
              [7061, 5258],
              [7085, 5306],
              [7121, 5290],
              [7079, 5252],
              [7097, 5223],
              [7123, 5229],
              [7103, 5138],
              [7185, 5082],
              [7233, 5085],
              [7280, 5002],
              [7308, 4932],
              [7306, 4879],
              [7360, 4851],
              [7334, 4831],
              [7376, 4810],
              [7391, 4772],
              [7456, 4799],
              [7427, 4755],
              [7462, 4735],
              [7495, 4674],
              [7540, 4697],
              [7523, 4653],
              [7540, 4648],
              [7573, 4585],
              [7546, 4577],
              [7556, 4542],
              [7591, 4529],
              [7551, 4500],
              [7495, 4506],
              [7460, 4490],
              [7407, 4493],
              [7395, 4431],
              [7370, 4410],
              [7334, 4432],
              [7278, 4425],
              [7213, 4452],
              [7205, 4438],
              [7258, 4347],
              [7143, 4362],
              [7217, 4321],
              [7224, 4262],
              [7187, 4269],
              [7177, 4221],
              [7215, 4182],
              [7213, 4142],
              [7271, 4119],
              [7319, 4084],
              [7385, 4084],
              [7410, 4013],
              [7363, 3992],
              [7398, 3952],
              [7472, 3942],
              [7476, 3993]
            ]
          ],
          [
            [
              [8074, 3597],
              [8108, 3629],
              [8214, 3666],
              [8342, 3692],
              [8405, 3684],
              [8451, 3700],
              [8505, 3667],
              [8443, 3617],
              [8321, 3578],
              [8242, 3568],
              [8220, 3587],
              [8166, 3594],
              [8090, 3580],
              [8074, 3597]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.ON',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.29,
        'hc-middle-y': 0.37,
        'hc-key': 'ca-on',
        'hc-a2': 'ON',
        labelrank: '2',
        hasc: 'CA.ON',
        'alt-name': 'Upper Canada',
        'woe-id': '2344922',
        subregion: 'Ontario',
        fips: 'CA08',
        'postal-code': 'ON',
        name: 'Ontario',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Eastern Canada',
        longitude: '-84.79430000000001',
        'woe-name': 'Ontario',
        latitude: '50.5244',
        'woe-label': 'Ontario, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [6059, 2877],
              [6012, 2914],
              [6005, 2956],
              [6022, 2981],
              [6030, 2960],
              [6059, 2877]
            ]
          ],
          [
            [
              [7249, 1970],
              [7235, 1932],
              [7216, 1901],
              [7192, 1894],
              [7146, 1838],
              [7087, 1700],
              [7052, 1656],
              [6996, 1623],
              [6958, 1543],
              [6890, 1512],
              [6866, 1525],
              [6722, 1440],
              [6655, 1394],
              [6609, 1335],
              [6586, 1250],
              [6605, 1236],
              [6666, 1245],
              [6701, 1279],
              [6713, 1237],
              [6748, 1215],
              [6709, 1185],
              [6629, 1154],
              [6560, 1112],
              [6525, 1047],
              [6451, 1046],
              [6384, 1020],
              [6331, 945],
              [6331, 914],
              [6255, 857],
              [6248, 802],
              [6221, 823],
              [6176, 798],
              [6137, 807],
              [6129, 860],
              [6231, 898],
              [6224, 934],
              [6195, 928],
              [6196, 1050],
              [6227, 1076],
              [6274, 1160],
              [6225, 1311],
              [6231, 1371],
              [6261, 1446],
              [6225, 1523],
              [6153, 1568],
              [6213, 1584],
              [6237, 1532],
              [6285, 1541],
              [6272, 1495],
              [6299, 1507],
              [6314, 1460],
              [6332, 1496],
              [6449, 1478],
              [6451, 1530],
              [6414, 1542],
              [6445, 1570],
              [6486, 1565],
              [6403, 1619],
              [6399, 1663],
              [6350, 1660],
              [6248, 1755],
              [6187, 1737],
              [6105, 1756],
              [6029, 1731],
              [5989, 1732],
              [5899, 1705],
              [5751, 1699],
              [5776, 1681],
              [5760, 1642],
              [5707, 1710],
              [5709, 1733],
              [5636, 1717],
              [5623, 1792],
              [5583, 1806],
              [5593, 1882],
              [5512, 1933],
              [5520, 2004],
              [5505, 2012],
              [5435, 1984],
              [5369, 1981],
              [5328, 2012],
              [5278, 2097],
              [5245, 2132],
              [5201, 2130],
              [5121, 2104],
              [5005, 2128],
              [4971, 2120],
              [5001, 2085],
              [5020, 2103],
              [5077, 2091],
              [5022, 2077],
              [4995, 2036],
              [4947, 2002],
              [4975, 2054],
              [4946, 2083],
              [4932, 1975],
              [4911, 2013],
              [4858, 1974],
              [4855, 1900],
              [4822, 1865],
              [4764, 1858],
              [4731, 1876],
              [4642, 1857],
              [4617, 1882],
              [4550, 1828],
              [4508, 1835],
              [4449, 1879],
              [4402, 1849],
              [4354, 1911],
              [4262, 1920],
              [4192, 1885],
              [4171, 1910],
              [4118, 1907],
              [4044, 1934],
              [4016, 2039],
              [3966, 2051],
              [3891, 2811],
              [4056, 3018],
              [4179, 3213],
              [4305, 3418],
              [4442, 3641],
              [4539, 3802],
              [4628, 3749],
              [4671, 3737],
              [4738, 3662],
              [4815, 3654],
              [4908, 3629],
              [4986, 3621],
              [5026, 3591],
              [5065, 3586],
              [5066, 3559],
              [5093, 3578],
              [5137, 3578],
              [5215, 3618],
              [5252, 3611],
              [5429, 3633],
              [5454, 3575],
              [5456, 3472],
              [5464, 3439],
              [5498, 3412],
              [5529, 3363],
              [5531, 3316],
              [5564, 3251],
              [5553, 3235],
              [5561, 3179],
              [5689, 3100],
              [5696, 3070],
              [5739, 3035],
              [5795, 3029],
              [5865, 2985],
              [5911, 2918],
              [5958, 2919],
              [6018, 2899],
              [6061, 2872],
              [6310, 2164],
              [6309, 2137],
              [6358, 2067],
              [6467, 1975],
              [6521, 1947],
              [6684, 1972],
              [6818, 1928],
              [6835, 1956],
              [6882, 1904],
              [6935, 1899],
              [6975, 1926],
              [7009, 1912],
              [7081, 1985],
              [7167, 2041],
              [7211, 2040],
              [7221, 1982],
              [7249, 1970]
            ]
          ],
          [
            [
              [6115, 1619],
              [5968, 1636],
              [5841, 1622],
              [5854, 1651],
              [5897, 1645],
              [5936, 1673],
              [5953, 1644],
              [6017, 1704],
              [6046, 1674],
              [6065, 1711],
              [6102, 1678],
              [6133, 1676],
              [6115, 1619]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.NB',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.51,
        'hc-key': 'ca-nb',
        'hc-a2': 'NB',
        labelrank: '2',
        hasc: 'CA.NB',
        'alt-name': 'Nouveau-Brunswick|Acadia',
        'woe-id': '2344918',
        subregion: 'Atlantic Canada',
        fips: 'CA04',
        'postal-code': 'NB',
        name: 'New Brunswick',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Eastern Canada',
        longitude: '-66.4558',
        'woe-name': 'New Brunswick',
        latitude: '46.5822',
        'woe-label': 'New Brunswick, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [8598, 2894],
            [8586, 2879],
            [8586, 2845],
            [8572, 2807],
            [8544, 2836],
            [8547, 2765],
            [8492, 2686],
            [8441, 2589],
            [8415, 2586],
            [8385, 2522],
            [8368, 2531],
            [8324, 2480],
            [8302, 2501],
            [8248, 2463],
            [8218, 2476],
            [8197, 2529],
            [8117, 2548],
            [8100, 2585],
            [7978, 2793],
            [7893, 2823],
            [7815, 2741],
            [7783, 2750],
            [7835, 2815],
            [7844, 2851],
            [7805, 2924],
            [7832, 2957],
            [7897, 2994],
            [7938, 2986],
            [7997, 3052],
            [8047, 3101],
            [8063, 3094],
            [8139, 3113],
            [8191, 3083],
            [8228, 3144],
            [8303, 3182],
            [8291, 3240],
            [8314, 3205],
            [8295, 3149],
            [8311, 3108],
            [8312, 3034],
            [8293, 2993],
            [8363, 3037],
            [8377, 2992],
            [8506, 2901],
            [8618, 2941],
            [8598, 2894]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.NS',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.23,
        'hc-middle-y': 0.8,
        'hc-key': 'ca-ns',
        'hc-a2': 'NS',
        labelrank: '2',
        hasc: 'CA.NS',
        'alt-name': 'Acadia|Nouvelle-Écosse',
        'woe-id': '2344921',
        subregion: 'Atlantic Canada',
        fips: 'CA07',
        'postal-code': 'NS',
        name: 'Nova Scotia',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Eastern Canada',
        longitude: '-62.8113',
        'woe-name': 'Nova Scotia',
        latitude: '45.2293',
        'woe-label': 'Nova Scotia, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8586, 2845],
              [8586, 2879],
              [8598, 2894],
              [8641, 2895],
              [8683, 2921],
              [8730, 2909],
              [8744, 2941],
              [8816, 2965],
              [8851, 2960],
              [8887, 3059],
              [8914, 3028],
              [8961, 3036],
              [8972, 3062],
              [9029, 3037],
              [9017, 3003],
              [9078, 3041],
              [9078, 3008],
              [9008, 2946],
              [8986, 2878],
              [8940, 2827],
              [8891, 2732],
              [8871, 2748],
              [8866, 2703],
              [8821, 2683],
              [8850, 2650],
              [8736, 2601],
              [8765, 2548],
              [8752, 2414],
              [8730, 2359],
              [8700, 2346],
              [8709, 2320],
              [8667, 2276],
              [8604, 2320],
              [8583, 2287],
              [8530, 2346],
              [8514, 2404],
              [8526, 2468],
              [8502, 2460],
              [8591, 2663],
              [8639, 2741],
              [8662, 2699],
              [8713, 2786],
              [8765, 2834],
              [8730, 2820],
              [8597, 2740],
              [8560, 2693],
              [8551, 2715],
              [8586, 2845]
            ]
          ],
          [
            [
              [9021, 3144],
              [9006, 3113],
              [9066, 3131],
              [9054, 3151],
              [9067, 3218],
              [9042, 3169],
              [9025, 3175],
              [9027, 3253],
              [9039, 3288],
              [9119, 3303],
              [9144, 3278],
              [9115, 3153],
              [9063, 3076],
              [9004, 3053],
              [8970, 3069],
              [8916, 3122],
              [8920, 3237],
              [8903, 3321],
              [8906, 3387],
              [8935, 3404],
              [8992, 3334],
              [9010, 3250],
              [9026, 3267],
              [9014, 3198],
              [9021, 3144]
            ]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.PE',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.76,
        'hc-middle-y': 0.48,
        'hc-key': 'ca-pe',
        'hc-a2': 'PE',
        labelrank: '2',
        hasc: 'CA.PE',
        'alt-name': 'Île de Saint-Jean|Île du Prince-Édouard',
        'woe-id': '2344923',
        subregion: 'Atlantic Canada',
        fips: 'CA09',
        'postal-code': 'PE',
        name: 'Prince Edward Island',
        country: 'Canada',
        'type-en': 'Province',
        region: 'Eastern Canada',
        longitude: '-63.3862',
        'woe-name': 'Prince Edward Island',
        latitude: '46.3417',
        'woe-label': 'Prince Edward Island, CA, Canada',
        type: 'Province'
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [8756, 2995],
            [8726, 2997],
            [8716, 3026],
            [8678, 2988],
            [8624, 2973],
            [8588, 2996],
            [8536, 2966],
            [8512, 3001],
            [8465, 2993],
            [8473, 3101],
            [8495, 3039],
            [8586, 3011],
            [8580, 3037],
            [8652, 3041],
            [8736, 3116],
            [8808, 3159],
            [8771, 3108],
            [8796, 3020],
            [8756, 2995]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      id: 'CA.YT',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.47,
        'hc-middle-y': 0.52,
        'hc-key': 'ca-yt',
        'hc-a2': 'YT',
        labelrank: '2',
        hasc: 'CA.YT',
        'alt-name': 'Yukon Territory|Territoire du Yukon|Yukon|Yuk¢n',
        'woe-id': '2344926',
        subregion: null,
        fips: 'CA12',
        'postal-code': 'YT',
        name: 'Yukon',
        country: 'Canada',
        'type-en': 'Territory',
        region: 'Northern Canada',
        longitude: '-135.7',
        'woe-name': 'Yukon',
        latitude: '63.6088',
        'woe-label': 'Yukon Territory, CA, Canada',
        type: 'Territoire'
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [639, 4744],
            [-860, 5470],
            [-861, 5470],
            [-863, 5491],
            [-824, 5537],
            [-873, 5565],
            [-926, 5561],
            [-950, 5605],
            [-969, 5598],
            [-999, 5645],
            [153, 7343],
            [197, 7300],
            [220, 7291],
            [257, 7238],
            [257, 7210],
            [283, 7124],
            [322, 7050],
            [350, 7015],
            [369, 7013],
            [237, 6786],
            [238, 6745],
            [223, 6706],
            [193, 6675],
            [178, 6637],
            [354, 6539],
            [337, 6544],
            [338, 6497],
            [325, 6485],
            [326, 6443],
            [283, 6404],
            [300, 6391],
            [268, 6353],
            [277, 6316],
            [325, 6311],
            [309, 6294],
            [354, 6297],
            [363, 6271],
            [335, 6261],
            [341, 6194],
            [272, 6153],
            [255, 6133],
            [274, 6092],
            [229, 6052],
            [265, 6015],
            [279, 5965],
            [254, 5942],
            [299, 5942],
            [316, 5923],
            [308, 5817],
            [347, 5753],
            [337, 5739],
            [343, 5681],
            [301, 5662],
            [306, 5605],
            [326, 5592],
            [292, 5554],
            [295, 5494],
            [313, 5455],
            [286, 5429],
            [285, 5381],
            [314, 5354],
            [340, 5358],
            [357, 5247],
            [384, 5194],
            [418, 5169],
            [405, 5077],
            [388, 5020],
            [476, 4991],
            [495, 5005],
            [544, 4961],
            [630, 4971],
            [629, 4930],
            [607, 4913],
            [639, 4744]
          ]
        ]
      }
    }
  ]
}
